//#region src/generated/schemas.gen.ts
var e = {
	type: "string",
	enum: ["VASCO"],
	description: "The fulfilment platform."
}, t = {
	type: "string",
	enum: ["status"]
}, n = {
	type: "string",
	format: "uuid"
}, r = {
	type: "string",
	enum: ["ACTIVE", "INACTIVE"],
	description: "The status of the product."
}, i = {
	type: "string",
	minLength: 1,
	maxLength: 50
}, a = {
	type: "string",
	enum: ["ASC", "DESC"],
	description: "The sort direction."
}, o = {
	type: "object",
	additionalProperties: {
		type: "object",
		properties: {
			free: {
				type: "integer",
				minimum: -9007199254740991,
				maximum: 9007199254740991,
				description: "The amount of free stock of the product."
			},
			value: {
				type: "integer",
				minimum: 0,
				maximum: 9007199254740991,
				description: "The amount of stock of the product."
			}
		},
		required: ["free", "value"]
	},
	propertyNames: { $ref: "#/components/schemas/FulfilmentPlatform" }
}, s = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The ID of the product."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The datetime the product was created"
		},
		name: {
			type: "string",
			minLength: 1,
			maxLength: 250,
			description: "The name of the product."
		},
		shopIds: {
			type: "array",
			items: {
				type: "string",
				minLength: 1,
				maxLength: 50
			},
			maxItems: 500
		},
		status: {
			type: "string",
			enum: ["ACTIVE", "INACTIVE"],
			description: "The status of the product."
		},
		trackInventory: {
			type: "boolean",
			description: "Whether the product its inventory should be tracked."
		},
		barcode: {
			type: "string",
			minLength: 6,
			maxLength: 24,
			description: "The barcode of the product."
		},
		children: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: {
						type: "string",
						format: "uuid",
						description: "The ID of the product."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e3,
						description: "The quantity of the product in the parent product."
					}
				},
				required: ["id", "quantity"]
			},
			maxItems: 50
		},
		containsDangerousSubstances: {
			type: "boolean",
			description: "Whether the product contains dangerous substances."
		},
		countryCodeOfOrigin: {
			type: "string",
			enum: /* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split("."),
			description: "The country code of origin of the product."
		},
		descriptions: {
			type: "array",
			items: {
				type: "object",
				properties: {
					text: {
						type: "string",
						minLength: 1,
						maxLength: 2500,
						description: "The text of one of the product descriptions."
					},
					languageCode: {
						type: "string",
						minLength: 2,
						maxLength: 2,
						description: "The language code (ISO 639-1) of one of the product descriptions."
					}
				},
				required: ["text", "languageCode"]
			},
			minItems: 1,
			maxItems: 200,
			description: "The descriptions of the product."
		},
		dimensions: {
			type: "object",
			properties: {
				height: {
					type: "object",
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							description: "The length value in provided unit."
						},
						unit: {
							type: "string",
							enum: ["cm"],
							description: "The length unit of the provided value."
						}
					},
					required: ["value", "unit"],
					description: "The height of the product."
				},
				length: {
					type: "object",
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							description: "The length value in provided unit."
						},
						unit: {
							type: "string",
							enum: ["cm"],
							description: "The length unit of the provided value."
						}
					},
					required: ["value", "unit"],
					description: "The length of the product."
				},
				weight: {
					type: "object",
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							description: "The weight value in provided unit."
						},
						unit: {
							type: "string",
							enum: ["gr", "kg"],
							description: "The weight unit of the provided value."
						}
					},
					required: ["value", "unit"],
					description: "The weight of the product."
				},
				width: {
					type: "object",
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							description: "The length value in provided unit."
						},
						unit: {
							type: "string",
							enum: ["cm"],
							description: "The length unit of the provided value."
						}
					},
					required: ["value", "unit"],
					description: "The width of the product."
				}
			},
			required: [
				"height",
				"length",
				"weight",
				"width"
			],
			description: "The dimensions of the product."
		},
		ean: {
			type: "string",
			description: "The EAN of the product, either 8 or 13 characters long."
		},
		fulfilmentPlatforms: {
			type: "array",
			items: { $ref: "#/components/schemas/FulfilmentPlatform" },
			minItems: 1,
			maxItems: 1,
			description: "The fulfilment platforms the product is available on."
		},
		hasUnlimitedShelfLife: {
			type: "boolean",
			description: "Whether the product has an unlimited shelf life."
		},
		hsCode: {
			type: "string",
			minLength: 6,
			maxLength: 10,
			description: "The HS code of the product."
		},
		parents: {
			type: "array",
			items: {
				type: "string",
				format: "uuid",
				description: "The ID of the product."
			},
			minItems: 1,
			maxItems: 100
		},
		purchasePrice: {
			type: "object",
			properties: {
				currency: {
					type: "string",
					minLength: 3,
					maxLength: 3
				},
				integral: {
					type: "integer",
					minimum: 0,
					maximum: 9007199254740991
				},
				fractional: {
					type: "integer",
					minimum: 0,
					maximum: 99
				}
			},
			required: [
				"currency",
				"integral",
				"fractional"
			],
			description: "The purchase price of the product, excluding VAT."
		},
		salesChannels: {
			type: "array",
			items: { oneOf: [
				{
					type: "object",
					properties: {
						sourceId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The product ID in the e-commerce platform."
						},
						salesChannelId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The sales channel ID of the e-commerce platform."
						},
						ecommercePlatformName: {
							type: "string",
							enum: ["bol"]
						}
					},
					required: [
						"sourceId",
						"salesChannelId",
						"ecommercePlatformName"
					]
				},
				{
					type: "object",
					properties: {
						sourceId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The product ID in the e-commerce platform."
						},
						salesChannelId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The sales channel ID of the e-commerce platform."
						},
						ecommercePlatformName: {
							type: "string",
							enum: ["lightspeed"]
						}
					},
					required: [
						"sourceId",
						"salesChannelId",
						"ecommercePlatformName"
					]
				},
				{
					type: "object",
					properties: {
						sourceId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The product ID in the e-commerce platform."
						},
						salesChannelId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The sales channel ID of the e-commerce platform."
						},
						ecommercePlatformName: {
							type: "string",
							enum: ["magento"]
						}
					},
					required: [
						"sourceId",
						"salesChannelId",
						"ecommercePlatformName"
					]
				},
				{
					type: "object",
					properties: {
						sourceId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The product ID in the e-commerce platform."
						},
						salesChannelId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The sales channel ID of the e-commerce platform."
						},
						ecommercePlatformName: {
							type: "string",
							enum: ["presta"]
						}
					},
					required: [
						"sourceId",
						"salesChannelId",
						"ecommercePlatformName"
					]
				},
				{
					type: "object",
					properties: {
						sourceId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The product ID in the e-commerce platform."
						},
						salesChannelId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The sales channel ID of the e-commerce platform."
						},
						ecommercePlatformName: {
							type: "string",
							enum: ["shopify"]
						},
						inventoryItemId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The inventory item ID in shopify."
						},
						inventoryLocationId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The location id of the product in shopify"
						}
					},
					required: [
						"sourceId",
						"salesChannelId",
						"ecommercePlatformName"
					]
				},
				{
					type: "object",
					properties: {
						sourceId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The product ID in the e-commerce platform."
						},
						salesChannelId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The sales channel ID of the e-commerce platform."
						},
						ecommercePlatformName: {
							type: "string",
							enum: ["woocommerce"]
						}
					},
					required: [
						"sourceId",
						"salesChannelId",
						"ecommercePlatformName"
					]
				}
			] },
			description: "References to the sales channels per e-commerce platform."
		},
		salesPrice: {
			type: "object",
			properties: {
				currency: {
					type: "string",
					minLength: 3,
					maxLength: 3
				},
				integral: {
					type: "integer",
					minimum: 0,
					maximum: 9007199254740991
				},
				fractional: {
					type: "integer",
					minimum: 0,
					maximum: 99
				},
				taxRate: {
					type: "integer",
					minimum: 0,
					maximum: 100
				}
			},
			required: [
				"currency",
				"integral",
				"fractional",
				"taxRate"
			],
			description: "The sales price of the product, including VAT."
		},
		sku: {
			type: "string",
			minLength: 1,
			maxLength: 200,
			description: "The SKU of the product."
		},
		stock: { $ref: "#/components/schemas/Stock" },
		updatedAt: {
			type: "string",
			format: "date-time",
			description: "The datetime the product was last updated."
		}
	},
	required: [
		"id",
		"createdAt",
		"name",
		"status",
		"trackInventory"
	]
}, c = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: [
				"about:blank",
				"urn:problem:client",
				"urn:problem:invalid-request-syntax",
				"urn:problem:not-found",
				"urn:problem:server",
				"urn:problem:unauthorized",
				"urn:problem:unsupported-media-type"
			],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "integer",
			enum: [
				400,
				401,
				404,
				415,
				500
			],
			description: "The HTTP status code generated by the origin server."
		},
		title: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "A short human-readable summary of the problem type."
		},
		detail: {
			type: "string",
			minLength: 1,
			maxLength: 5e3,
			description: "A human-readable explanation specific to this occurrence of the problem."
		},
		instance: {
			type: "string",
			format: "uri",
			description: "A URI reference that identifies the specific occurrence of the problem."
		},
		cause: { description: "The cause of this problem when debug mode is enabled." }
	},
	required: [
		"type",
		"status",
		"title",
		"detail",
		"instance"
	]
}, l = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:invalid-request-syntax"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the syntactic violations."
		}
	},
	required: ["errors"]
}] }, u = { VASCO: "VASCO" }, d = { STATUS: "status" }, f = {
	ACTIVE: "ACTIVE",
	INACTIVE: "INACTIVE"
}, p = {
	ASC: "ASC",
	DESC: "DESC"
}, m = {
	SalesChannelStatusChanged: "SalesChannelStatusChanged",
	ProductCreated: "ProductCreated",
	ProductUpdated: "ProductUpdated",
	OrderCreated: "OrderCreated",
	OrderDeleted: "OrderDeleted",
	OrderUpdated: "OrderUpdated",
	Printed: "Printed",
	PrintErrored: "PrintErrored"
}, h = {
	Account: "account",
	Shop: "shop",
	Order: "ORDER",
	Product: "PRODUCT",
	Print: "PRINT"
}, g = {
	Event: "Event",
	Order: "Order",
	Printing: "Printing",
	Product: "Product"
};
//#endregion
//#region ../../node_modules/.pnpm/@vue+shared@3.5.30/node_modules/@vue/shared/dist/shared.esm-bundler.js
/* @__NO_SIDE_EFFECTS__ */
function _(e) {
	let t = /* @__PURE__ */ Object.create(null);
	for (let n of e.split(",")) t[n] = 1;
	return (e) => e in t;
}
var v = process.env.NODE_ENV === "production" ? {} : Object.freeze({});
process.env.NODE_ENV === "production" || Object.freeze([]);
var y = () => {}, b = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), x = Object.assign, ee = (e, t) => {
	let n = e.indexOf(t);
	n > -1 && e.splice(n, 1);
}, te = Object.prototype.hasOwnProperty, S = (e, t) => te.call(e, t), C = Array.isArray, ne = (e) => ce(e) === "[object Map]", re = (e) => ce(e) === "[object Set]", w = (e) => typeof e == "function", ie = (e) => typeof e == "string", ae = (e) => typeof e == "symbol", T = (e) => typeof e == "object" && !!e, oe = (e) => (T(e) || w(e)) && w(e.then) && w(e.catch), se = Object.prototype.toString, ce = (e) => se.call(e), le = (e) => ce(e).slice(8, -1), ue = (e) => ce(e) === "[object Object]", de = (e) => ie(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, fe = ((e) => {
	let t = /* @__PURE__ */ Object.create(null);
	return ((n) => t[n] || (t[n] = e(n)));
})((e) => e.charAt(0).toUpperCase() + e.slice(1)), pe = (e, t) => !Object.is(e, t), me = (e, t, n, r = !1) => {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		writable: r,
		value: n
	});
}, he, ge = () => he ||= typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
function _e(e) {
	if (C(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = ie(r) ? xe(r) : _e(r);
			if (i) for (let e in i) t[e] = i[e];
		}
		return t;
	} else if (ie(e) || T(e)) return e;
}
var ve = /;(?![^(]*\))/g, ye = /:([^]+)/, be = /\/\*[^]*?\*\//g;
function xe(e) {
	let t = {};
	return e.replace(be, "").split(ve).forEach((e) => {
		if (e) {
			let n = e.split(ye);
			n.length > 1 && (t[n[0].trim()] = n[1].trim());
		}
	}), t;
}
function Se(e) {
	let t = "";
	if (ie(e)) t = e;
	else if (C(e)) for (let n = 0; n < e.length; n++) {
		let r = Se(e[n]);
		r && (t += r + " ");
	}
	else if (T(e)) for (let n in e) e[n] && (t += n + " ");
	return t.trim();
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+reactivity@3.5.30/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
function Ce(e, ...t) {
	console.warn(`[Vue warn] ${e}`, ...t);
}
var we;
function Te() {
	return we;
}
var E, Ee = /* @__PURE__ */ new WeakSet(), De = class {
	constructor(e) {
		this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, we && we.active && we.effects.push(this);
	}
	pause() {
		this.flags |= 64;
	}
	resume() {
		this.flags & 64 && (this.flags &= -65, Ee.has(this) && (Ee.delete(this), this.trigger()));
	}
	notify() {
		this.flags & 2 && !(this.flags & 32) || this.flags & 8 || je(this);
	}
	run() {
		if (!(this.flags & 1)) return this.fn();
		this.flags |= 2, Ue(this), Pe(this);
		let e = E, t = D;
		E = this, D = !0;
		try {
			return this.fn();
		} finally {
			process.env.NODE_ENV !== "production" && E !== this && Ce("Active effect was not restored correctly - this is likely a Vue internal bug."), Fe(this), E = e, D = t, this.flags &= -3;
		}
	}
	stop() {
		if (this.flags & 1) {
			for (let e = this.deps; e; e = e.nextDep) Re(e);
			this.deps = this.depsTail = void 0, Ue(this), this.onStop && this.onStop(), this.flags &= -2;
		}
	}
	trigger() {
		this.flags & 64 ? Ee.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
	}
	runIfDirty() {
		Ie(this) && this.run();
	}
	get dirty() {
		return Ie(this);
	}
}, Oe = 0, ke, Ae;
function je(e, t = !1) {
	if (e.flags |= 8, t) {
		e.next = Ae, Ae = e;
		return;
	}
	e.next = ke, ke = e;
}
function Me() {
	Oe++;
}
function Ne() {
	if (--Oe > 0) return;
	if (Ae) {
		let e = Ae;
		for (Ae = void 0; e;) {
			let t = e.next;
			e.next = void 0, e.flags &= -9, e = t;
		}
	}
	let e;
	for (; ke;) {
		let t = ke;
		for (ke = void 0; t;) {
			let n = t.next;
			if (t.next = void 0, t.flags &= -9, t.flags & 1) try {
				t.trigger();
			} catch (t) {
				e ||= t;
			}
			t = n;
		}
	}
	if (e) throw e;
}
function Pe(e) {
	for (let t = e.deps; t; t = t.nextDep) t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function Fe(e) {
	let t, n = e.depsTail, r = n;
	for (; r;) {
		let e = r.prevDep;
		r.version === -1 ? (r === n && (n = e), Re(r), ze(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = e;
	}
	e.deps = t, e.depsTail = n;
}
function Ie(e) {
	for (let t = e.deps; t; t = t.nextDep) if (t.dep.version !== t.version || t.dep.computed && (Le(t.dep.computed) || t.dep.version !== t.version)) return !0;
	return !!e._dirty;
}
function Le(e) {
	if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === We) || (e.globalVersion = We, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !Ie(e)))) return;
	e.flags |= 2;
	let t = e.dep, n = E, r = D;
	E = e, D = !0;
	try {
		Pe(e);
		let n = e.fn(e._value);
		(t.version === 0 || pe(n, e._value)) && (e.flags |= 128, e._value = n, t.version++);
	} catch (e) {
		throw t.version++, e;
	} finally {
		E = n, D = r, Fe(e), e.flags &= -3;
	}
}
function Re(e, t = !1) {
	let { dep: n, prevSub: r, nextSub: i } = e;
	if (r && (r.nextSub = i, e.prevSub = void 0), i && (i.prevSub = r, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = i), n.subs === e && (n.subs = r, !r && n.computed)) {
		n.computed.flags &= -5;
		for (let e = n.computed.deps; e; e = e.nextDep) Re(e, !0);
	}
	!t && !--n.sc && n.map && n.map.delete(n.key);
}
function ze(e) {
	let { prevDep: t, nextDep: n } = e;
	t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
var D = !0, Be = [];
function Ve() {
	Be.push(D), D = !1;
}
function He() {
	let e = Be.pop();
	D = e === void 0 ? !0 : e;
}
function Ue(e) {
	let { cleanup: t } = e;
	if (e.cleanup = void 0, t) {
		let e = E;
		E = void 0;
		try {
			t();
		} finally {
			E = e;
		}
	}
}
var We = 0, Ge = class {
	constructor(e, t) {
		this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
	}
}, Ke = class {
	constructor(e) {
		this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
	}
	track(e) {
		if (!E || !D || E === this.computed) return;
		let t = this.activeLink;
		if (t === void 0 || t.sub !== E) t = this.activeLink = new Ge(E, this), E.deps ? (t.prevDep = E.depsTail, E.depsTail.nextDep = t, E.depsTail = t) : E.deps = E.depsTail = t, qe(t);
		else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
			let e = t.nextDep;
			e.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = e), t.prevDep = E.depsTail, t.nextDep = void 0, E.depsTail.nextDep = t, E.depsTail = t, E.deps === t && (E.deps = e);
		}
		return process.env.NODE_ENV !== "production" && E.onTrack && E.onTrack(x({ effect: E }, e)), t;
	}
	trigger(e) {
		this.version++, We++, this.notify(e);
	}
	notify(e) {
		Me();
		try {
			if (process.env.NODE_ENV !== "production") for (let t = this.subsHead; t; t = t.nextSub) t.sub.onTrigger && !(t.sub.flags & 8) && t.sub.onTrigger(x({ effect: t.sub }, e));
			for (let e = this.subs; e; e = e.prevSub) e.sub.notify() && e.sub.dep.notify();
		} finally {
			Ne();
		}
	}
};
function qe(e) {
	if (e.dep.sc++, e.sub.flags & 4) {
		let t = e.dep.computed;
		if (t && !e.dep.subs) {
			t.flags |= 20;
			for (let e = t.deps; e; e = e.nextDep) qe(e);
		}
		let n = e.dep.subs;
		n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
	}
}
var Je = /* @__PURE__ */ new WeakMap(), Ye = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Object iterate"), Xe = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Map keys iterate"), Ze = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Array iterate");
function O(e, t, n) {
	if (D && E) {
		let r = Je.get(e);
		r || Je.set(e, r = /* @__PURE__ */ new Map());
		let i = r.get(n);
		i || (r.set(n, i = new Ke()), i.map = r, i.key = n), process.env.NODE_ENV === "production" ? i.track() : i.track({
			target: e,
			type: t,
			key: n
		});
	}
}
function Qe(e, t, n, r, i, a) {
	let o = Je.get(e);
	if (!o) {
		We++;
		return;
	}
	let s = (o) => {
		o && (process.env.NODE_ENV === "production" ? o.trigger() : o.trigger({
			target: e,
			type: t,
			key: n,
			newValue: r,
			oldValue: i,
			oldTarget: a
		}));
	};
	if (Me(), t === "clear") o.forEach(s);
	else {
		let i = C(e), a = i && de(n);
		if (i && n === "length") {
			let e = Number(r);
			o.forEach((t, n) => {
				(n === "length" || n === Ze || !ae(n) && n >= e) && s(t);
			});
		} else switch ((n !== void 0 || o.has(void 0)) && s(o.get(n)), a && s(o.get(Ze)), t) {
			case "add":
				i ? a && s(o.get("length")) : (s(o.get(Ye)), ne(e) && s(o.get(Xe)));
				break;
			case "delete":
				i || (s(o.get(Ye)), ne(e) && s(o.get(Xe)));
				break;
			case "set":
				ne(e) && s(o.get(Ye));
				break;
		}
	}
	Ne();
}
function $e(e) {
	let t = /* @__PURE__ */ A(e);
	return t === e ? t : (O(t, "iterate", Ze), /* @__PURE__ */ k(e) ? t : t.map(Ht));
}
function et(e) {
	return O(e = /* @__PURE__ */ A(e), "iterate", Ze), e;
}
function tt(e, t) {
	return /* @__PURE__ */ zt(e) ? Ut(/* @__PURE__ */ Rt(e) ? Ht(t) : t) : Ht(t);
}
var nt = {
	__proto__: null,
	[Symbol.iterator]() {
		return rt(this, Symbol.iterator, (e) => tt(this, e));
	},
	concat(...e) {
		return $e(this).concat(...e.map((e) => C(e) ? $e(e) : e));
	},
	entries() {
		return rt(this, "entries", (e) => (e[1] = tt(this, e[1]), e));
	},
	every(e, t) {
		return at(this, "every", e, t, void 0, arguments);
	},
	filter(e, t) {
		return at(this, "filter", e, t, (e) => e.map((e) => tt(this, e)), arguments);
	},
	find(e, t) {
		return at(this, "find", e, t, (e) => tt(this, e), arguments);
	},
	findIndex(e, t) {
		return at(this, "findIndex", e, t, void 0, arguments);
	},
	findLast(e, t) {
		return at(this, "findLast", e, t, (e) => tt(this, e), arguments);
	},
	findLastIndex(e, t) {
		return at(this, "findLastIndex", e, t, void 0, arguments);
	},
	forEach(e, t) {
		return at(this, "forEach", e, t, void 0, arguments);
	},
	includes(...e) {
		return st(this, "includes", e);
	},
	indexOf(...e) {
		return st(this, "indexOf", e);
	},
	join(e) {
		return $e(this).join(e);
	},
	lastIndexOf(...e) {
		return st(this, "lastIndexOf", e);
	},
	map(e, t) {
		return at(this, "map", e, t, void 0, arguments);
	},
	pop() {
		return ct(this, "pop");
	},
	push(...e) {
		return ct(this, "push", e);
	},
	reduce(e, ...t) {
		return ot(this, "reduce", e, t);
	},
	reduceRight(e, ...t) {
		return ot(this, "reduceRight", e, t);
	},
	shift() {
		return ct(this, "shift");
	},
	some(e, t) {
		return at(this, "some", e, t, void 0, arguments);
	},
	splice(...e) {
		return ct(this, "splice", e);
	},
	toReversed() {
		return $e(this).toReversed();
	},
	toSorted(e) {
		return $e(this).toSorted(e);
	},
	toSpliced(...e) {
		return $e(this).toSpliced(...e);
	},
	unshift(...e) {
		return ct(this, "unshift", e);
	},
	values() {
		return rt(this, "values", (e) => tt(this, e));
	}
};
function rt(e, t, n) {
	let r = et(e), i = r[t]();
	return r !== e && !/* @__PURE__ */ k(e) && (i._next = i.next, i.next = () => {
		let e = i._next();
		return e.done || (e.value = n(e.value)), e;
	}), i;
}
var it = Array.prototype;
function at(e, t, n, r, i, a) {
	let o = et(e), s = o !== e && !/* @__PURE__ */ k(e), c = o[t];
	if (c !== it[t]) {
		let t = c.apply(e, a);
		return s ? Ht(t) : t;
	}
	let l = n;
	o !== e && (s ? l = function(t, r) {
		return n.call(this, tt(e, t), r, e);
	} : n.length > 2 && (l = function(t, r) {
		return n.call(this, t, r, e);
	}));
	let u = c.call(o, l, r);
	return s && i ? i(u) : u;
}
function ot(e, t, n, r) {
	let i = et(e), a = i !== e && !/* @__PURE__ */ k(e), o = n, s = !1;
	i !== e && (a ? (s = r.length === 0, o = function(t, r, i) {
		return s && (s = !1, t = tt(e, t)), n.call(this, t, tt(e, r), i, e);
	}) : n.length > 3 && (o = function(t, r, i) {
		return n.call(this, t, r, i, e);
	}));
	let c = i[t](o, ...r);
	return s ? tt(e, c) : c;
}
function st(e, t, n) {
	let r = /* @__PURE__ */ A(e);
	O(r, "iterate", Ze);
	let i = r[t](...n);
	return (i === -1 || i === !1) && /* @__PURE__ */ Bt(n[0]) ? (n[0] = /* @__PURE__ */ A(n[0]), r[t](...n)) : i;
}
function ct(e, t, n = []) {
	Ve(), Me();
	let r = (/* @__PURE__ */ A(e))[t].apply(e, n);
	return Ne(), He(), r;
}
var lt = /* @__PURE__ */ _("__proto__,__v_isRef,__isVue"), ut = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(ae));
function dt(e) {
	ae(e) || (e = String(e));
	let t = /* @__PURE__ */ A(this);
	return O(t, "has", e), t.hasOwnProperty(e);
}
var ft = class {
	constructor(e = !1, t = !1) {
		this._isReadonly = e, this._isShallow = t;
	}
	get(e, t, n) {
		if (t === "__v_skip") return e.__v_skip;
		let r = this._isReadonly, i = this._isShallow;
		if (t === "__v_isReactive") return !r;
		if (t === "__v_isReadonly") return r;
		if (t === "__v_isShallow") return i;
		if (t === "__v_raw") return n === (r ? i ? jt : At : i ? kt : Ot).get(e) || Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
		let a = C(e);
		if (!r) {
			let e;
			if (a && (e = nt[t])) return e;
			if (t === "hasOwnProperty") return dt;
		}
		let o = Reflect.get(e, t, /* @__PURE__ */ j(e) ? e : n);
		if ((ae(t) ? ut.has(t) : lt(t)) || (r || O(e, "get", t), i)) return o;
		if (/* @__PURE__ */ j(o)) {
			let e = a && de(t) ? o : o.value;
			return r && T(e) ? /* @__PURE__ */ Ft(e) : e;
		}
		return T(o) ? r ? /* @__PURE__ */ Ft(o) : /* @__PURE__ */ Pt(o) : o;
	}
}, pt = class extends ft {
	constructor(e = !1) {
		super(!1, e);
	}
	set(e, t, n, r) {
		let i = e[t], a = C(e) && de(t);
		if (!this._isShallow) {
			let r = /* @__PURE__ */ zt(i);
			if (!/* @__PURE__ */ k(n) && !/* @__PURE__ */ zt(n) && (i = /* @__PURE__ */ A(i), n = /* @__PURE__ */ A(n)), !a && /* @__PURE__ */ j(i) && !/* @__PURE__ */ j(n)) return r ? (process.env.NODE_ENV !== "production" && Ce(`Set operation on key "${String(t)}" failed: target is readonly.`, e[t]), !0) : (i.value = n, !0);
		}
		let o = a ? Number(t) < e.length : S(e, t), s = Reflect.set(e, t, n, /* @__PURE__ */ j(e) ? e : r);
		return e === /* @__PURE__ */ A(r) && (o ? pe(n, i) && Qe(e, "set", t, n, i) : Qe(e, "add", t, n)), s;
	}
	deleteProperty(e, t) {
		let n = S(e, t), r = e[t], i = Reflect.deleteProperty(e, t);
		return i && n && Qe(e, "delete", t, void 0, r), i;
	}
	has(e, t) {
		let n = Reflect.has(e, t);
		return (!ae(t) || !ut.has(t)) && O(e, "has", t), n;
	}
	ownKeys(e) {
		return O(e, "iterate", C(e) ? "length" : Ye), Reflect.ownKeys(e);
	}
}, mt = class extends ft {
	constructor(e = !1) {
		super(!0, e);
	}
	set(e, t) {
		return process.env.NODE_ENV !== "production" && Ce(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
	deleteProperty(e, t) {
		return process.env.NODE_ENV !== "production" && Ce(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
}, ht = /* @__PURE__ */ new pt(), gt = /* @__PURE__ */ new mt(), _t = /* @__PURE__ */ new mt(!0), vt = (e) => e, yt = (e) => Reflect.getPrototypeOf(e);
function bt(e, t, n) {
	return function(...r) {
		let i = this.__v_raw, a = /* @__PURE__ */ A(i), o = ne(a), s = e === "entries" || e === Symbol.iterator && o, c = e === "keys" && o, l = i[e](...r), u = n ? vt : t ? Ut : Ht;
		return !t && O(a, "iterate", c ? Xe : Ye), x(Object.create(l), { next() {
			let { value: e, done: t } = l.next();
			return t ? {
				value: e,
				done: t
			} : {
				value: s ? [u(e[0]), u(e[1])] : u(e),
				done: t
			};
		} });
	};
}
function xt(e) {
	return function(...t) {
		if (process.env.NODE_ENV !== "production") {
			let n = t[0] ? `on key "${t[0]}" ` : "";
			Ce(`${fe(e)} operation ${n}failed: target is readonly.`, /* @__PURE__ */ A(this));
		}
		return e === "delete" ? !1 : e === "clear" ? void 0 : this;
	};
}
function St(e, t) {
	let n = {
		get(n) {
			let r = this.__v_raw, i = /* @__PURE__ */ A(r), a = /* @__PURE__ */ A(n);
			e || (pe(n, a) && O(i, "get", n), O(i, "get", a));
			let { has: o } = yt(i), s = t ? vt : e ? Ut : Ht;
			if (o.call(i, n)) return s(r.get(n));
			if (o.call(i, a)) return s(r.get(a));
			r !== i && r.get(n);
		},
		get size() {
			let t = this.__v_raw;
			return !e && O(/* @__PURE__ */ A(t), "iterate", Ye), t.size;
		},
		has(t) {
			let n = this.__v_raw, r = /* @__PURE__ */ A(n), i = /* @__PURE__ */ A(t);
			return e || (pe(t, i) && O(r, "has", t), O(r, "has", i)), t === i ? n.has(t) : n.has(t) || n.has(i);
		},
		forEach(n, r) {
			let i = this, a = i.__v_raw, o = /* @__PURE__ */ A(a), s = t ? vt : e ? Ut : Ht;
			return !e && O(o, "iterate", Ye), a.forEach((e, t) => n.call(r, s(e), s(t), i));
		}
	};
	return x(n, e ? {
		add: xt("add"),
		set: xt("set"),
		delete: xt("delete"),
		clear: xt("clear")
	} : {
		add(e) {
			let n = /* @__PURE__ */ A(this), r = yt(n), i = /* @__PURE__ */ A(e), a = !t && !/* @__PURE__ */ k(e) && !/* @__PURE__ */ zt(e) ? i : e;
			return r.has.call(n, a) || pe(e, a) && r.has.call(n, e) || pe(i, a) && r.has.call(n, i) || (n.add(a), Qe(n, "add", a, a)), this;
		},
		set(e, n) {
			!t && !/* @__PURE__ */ k(n) && !/* @__PURE__ */ zt(n) && (n = /* @__PURE__ */ A(n));
			let r = /* @__PURE__ */ A(this), { has: i, get: a } = yt(r), o = i.call(r, e);
			o ? process.env.NODE_ENV !== "production" && Dt(r, i, e) : (e = /* @__PURE__ */ A(e), o = i.call(r, e));
			let s = a.call(r, e);
			return r.set(e, n), o ? pe(n, s) && Qe(r, "set", e, n, s) : Qe(r, "add", e, n), this;
		},
		delete(e) {
			let t = /* @__PURE__ */ A(this), { has: n, get: r } = yt(t), i = n.call(t, e);
			i ? process.env.NODE_ENV !== "production" && Dt(t, n, e) : (e = /* @__PURE__ */ A(e), i = n.call(t, e));
			let a = r ? r.call(t, e) : void 0, o = t.delete(e);
			return i && Qe(t, "delete", e, void 0, a), o;
		},
		clear() {
			let e = /* @__PURE__ */ A(this), t = e.size !== 0, n = process.env.NODE_ENV === "production" ? void 0 : ne(e) ? new Map(e) : new Set(e), r = e.clear();
			return t && Qe(e, "clear", void 0, void 0, n), r;
		}
	}), [
		"keys",
		"values",
		"entries",
		Symbol.iterator
	].forEach((r) => {
		n[r] = bt(r, e, t);
	}), n;
}
function Ct(e, t) {
	let n = St(e, t);
	return (t, r, i) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? t : Reflect.get(S(n, r) && r in t ? n : t, r, i);
}
var wt = { get: /* @__PURE__ */ Ct(!1, !1) }, Tt = { get: /* @__PURE__ */ Ct(!0, !1) }, Et = { get: /* @__PURE__ */ Ct(!0, !0) };
function Dt(e, t, n) {
	let r = /* @__PURE__ */ A(n);
	if (r !== n && t.call(e, r)) {
		let t = le(e);
		Ce(`Reactive ${t} contains both the raw and reactive versions of the same object${t === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
	}
}
var Ot = /* @__PURE__ */ new WeakMap(), kt = /* @__PURE__ */ new WeakMap(), At = /* @__PURE__ */ new WeakMap(), jt = /* @__PURE__ */ new WeakMap();
function Mt(e) {
	switch (e) {
		case "Object":
		case "Array": return 1;
		case "Map":
		case "Set":
		case "WeakMap":
		case "WeakSet": return 2;
		default: return 0;
	}
}
function Nt(e) {
	return e.__v_skip || !Object.isExtensible(e) ? 0 : Mt(le(e));
}
/* @__NO_SIDE_EFFECTS__ */
function Pt(e) {
	return /* @__PURE__ */ zt(e) ? e : Lt(e, !1, ht, wt, Ot);
}
/* @__NO_SIDE_EFFECTS__ */
function Ft(e) {
	return Lt(e, !0, gt, Tt, At);
}
/* @__NO_SIDE_EFFECTS__ */
function It(e) {
	return Lt(e, !0, _t, Et, jt);
}
function Lt(e, t, n, r, i) {
	if (!T(e)) return process.env.NODE_ENV !== "production" && Ce(`value cannot be made ${t ? "readonly" : "reactive"}: ${String(e)}`), e;
	if (e.__v_raw && !(t && e.__v_isReactive)) return e;
	let a = Nt(e);
	if (a === 0) return e;
	let o = i.get(e);
	if (o) return o;
	let s = new Proxy(e, a === 2 ? r : n);
	return i.set(e, s), s;
}
/* @__NO_SIDE_EFFECTS__ */
function Rt(e) {
	return /* @__PURE__ */ zt(e) ? /* @__PURE__ */ Rt(e.__v_raw) : !!(e && e.__v_isReactive);
}
/* @__NO_SIDE_EFFECTS__ */
function zt(e) {
	return !!(e && e.__v_isReadonly);
}
/* @__NO_SIDE_EFFECTS__ */
function k(e) {
	return !!(e && e.__v_isShallow);
}
/* @__NO_SIDE_EFFECTS__ */
function Bt(e) {
	return e ? !!e.__v_raw : !1;
}
/* @__NO_SIDE_EFFECTS__ */
function A(e) {
	let t = e && e.__v_raw;
	return t ? /* @__PURE__ */ A(t) : e;
}
function Vt(e) {
	return !S(e, "__v_skip") && Object.isExtensible(e) && me(e, "__v_skip", !0), e;
}
var Ht = (e) => T(e) ? /* @__PURE__ */ Pt(e) : e, Ut = (e) => T(e) ? /* @__PURE__ */ Ft(e) : e;
/* @__NO_SIDE_EFFECTS__ */
function j(e) {
	return e ? e.__v_isRef === !0 : !1;
}
function Wt(e) {
	return /* @__PURE__ */ j(e) ? e.value : e;
}
var Gt = {
	get: (e, t, n) => t === "__v_raw" ? e : Wt(Reflect.get(e, t, n)),
	set: (e, t, n, r) => {
		let i = e[t];
		return /* @__PURE__ */ j(i) && !/* @__PURE__ */ j(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
	}
};
function Kt(e) {
	return /* @__PURE__ */ Rt(e) ? e : new Proxy(e, Gt);
}
var qt = {}, Jt = /* @__PURE__ */ new WeakMap(), Yt = void 0;
function Xt(e, t = !1, n = Yt) {
	if (n) {
		let t = Jt.get(n);
		t || Jt.set(n, t = []), t.push(e);
	} else process.env.NODE_ENV !== "production" && !t && Ce("onWatcherCleanup() was called when there was no active watcher to associate with.");
}
function Zt(e, t, n = v) {
	let { immediate: r, deep: i, once: a, scheduler: o, augmentJob: s, call: c } = n, l = (e) => {
		(n.onWarn || Ce)("Invalid watch source: ", e, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
	}, u = (e) => i ? e : /* @__PURE__ */ k(e) || i === !1 || i === 0 ? Qt(e, 1) : Qt(e), d, f, p, m, h = !1, g = !1;
	if (/* @__PURE__ */ j(e) ? (f = () => e.value, h = /* @__PURE__ */ k(e)) : /* @__PURE__ */ Rt(e) ? (f = () => u(e), h = !0) : C(e) ? (g = !0, h = e.some((e) => /* @__PURE__ */ Rt(e) || /* @__PURE__ */ k(e)), f = () => e.map((e) => {
		if (/* @__PURE__ */ j(e)) return e.value;
		if (/* @__PURE__ */ Rt(e)) return u(e);
		if (w(e)) return c ? c(e, 2) : e();
		process.env.NODE_ENV !== "production" && l(e);
	})) : w(e) ? f = t ? c ? () => c(e, 2) : e : () => {
		if (p) {
			Ve();
			try {
				p();
			} finally {
				He();
			}
		}
		let t = Yt;
		Yt = d;
		try {
			return c ? c(e, 3, [m]) : e(m);
		} finally {
			Yt = t;
		}
	} : (f = y, process.env.NODE_ENV !== "production" && l(e)), t && i) {
		let e = f, t = i === !0 ? Infinity : i;
		f = () => Qt(e(), t);
	}
	let _ = Te(), b = () => {
		d.stop(), _ && _.active && ee(_.effects, d);
	};
	if (a && t) {
		let e = t;
		t = (...t) => {
			e(...t), b();
		};
	}
	let x = g ? Array(e.length).fill(qt) : qt, te = (e) => {
		if (!(!(d.flags & 1) || !d.dirty && !e)) if (t) {
			let e = d.run();
			if (i || h || (g ? e.some((e, t) => pe(e, x[t])) : pe(e, x))) {
				p && p();
				let n = Yt;
				Yt = d;
				try {
					let n = [
						e,
						x === qt ? void 0 : g && x[0] === qt ? [] : x,
						m
					];
					x = e, c ? c(t, 3, n) : t(...n);
				} finally {
					Yt = n;
				}
			}
		} else d.run();
	};
	return s && s(te), d = new De(f), d.scheduler = o ? () => o(te, !1) : te, m = (e) => Xt(e, !1, d), p = d.onStop = () => {
		let e = Jt.get(d);
		if (e) {
			if (c) c(e, 4);
			else for (let t of e) t();
			Jt.delete(d);
		}
	}, process.env.NODE_ENV !== "production" && (d.onTrack = n.onTrack, d.onTrigger = n.onTrigger), t ? r ? te(!0) : x = d.run() : o ? o(te.bind(null, !0), !0) : d.run(), b.pause = d.pause.bind(d), b.resume = d.resume.bind(d), b.stop = b, b;
}
function Qt(e, t = Infinity, n) {
	if (t <= 0 || !T(e) || e.__v_skip || (n ||= /* @__PURE__ */ new Map(), (n.get(e) || 0) >= t)) return e;
	if (n.set(e, t), t--, /* @__PURE__ */ j(e)) Qt(e.value, t, n);
	else if (C(e)) for (let r = 0; r < e.length; r++) Qt(e[r], t, n);
	else if (re(e) || ne(e)) e.forEach((e) => {
		Qt(e, t, n);
	});
	else if (ue(e)) {
		for (let r in e) Qt(e[r], t, n);
		for (let r of Object.getOwnPropertySymbols(e)) Object.prototype.propertyIsEnumerable.call(e, r) && Qt(e[r], t, n);
	}
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+runtime-core@3.5.30/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
var $t = [];
function en(e) {
	$t.push(e);
}
function tn() {
	$t.pop();
}
var nn = !1;
function M(e, ...t) {
	if (nn) return;
	nn = !0, Ve();
	let n = $t.length ? $t[$t.length - 1].component : null, r = n && n.appContext.config.warnHandler, i = rn();
	if (r) un(r, n, 11, [
		e + t.map((e) => e.toString?.call(e) ?? JSON.stringify(e)).join(""),
		n && n.proxy,
		i.map(({ vnode: e }) => `at <${Yr(n, e.type)}>`).join("\n"),
		i
	]);
	else {
		let n = [`[Vue warn]: ${e}`, ...t];
		i.length && n.push("\n", ...an(i)), console.warn(...n);
	}
	He(), nn = !1;
}
function rn() {
	let e = $t[$t.length - 1];
	if (!e) return [];
	let t = [];
	for (; e;) {
		let n = t[0];
		n && n.vnode === e ? n.recurseCount++ : t.push({
			vnode: e,
			recurseCount: 0
		});
		let r = e.component && e.component.parent;
		e = r && r.vnode;
	}
	return t;
}
function an(e) {
	let t = [];
	return e.forEach((e, n) => {
		t.push(...n === 0 ? [] : ["\n"], ...on(e));
	}), t;
}
function on({ vnode: e, recurseCount: t }) {
	let n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, i = ` at <${Yr(e.component, e.type, r)}`, a = ">" + n;
	return e.props ? [
		i,
		...sn(e.props),
		a
	] : [i + a];
}
function sn(e) {
	let t = [], n = Object.keys(e);
	return n.slice(0, 3).forEach((n) => {
		t.push(...cn(n, e[n]));
	}), n.length > 3 && t.push(" ..."), t;
}
function cn(e, t, n) {
	return ie(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : /* @__PURE__ */ j(t) ? (t = cn(e, /* @__PURE__ */ A(t.value), !0), n ? t : [
		`${e}=Ref<`,
		t,
		">"
	]) : w(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = /* @__PURE__ */ A(t), n ? t : [`${e}=`, t]);
}
var ln = {
	sp: "serverPrefetch hook",
	bc: "beforeCreate hook",
	c: "created hook",
	bm: "beforeMount hook",
	m: "mounted hook",
	bu: "beforeUpdate hook",
	u: "updated",
	bum: "beforeUnmount hook",
	um: "unmounted hook",
	a: "activated hook",
	da: "deactivated hook",
	ec: "errorCaptured hook",
	rtc: "renderTracked hook",
	rtg: "renderTriggered hook",
	0: "setup function",
	1: "render function",
	2: "watcher getter",
	3: "watcher callback",
	4: "watcher cleanup function",
	5: "native event handler",
	6: "component event handler",
	7: "vnode hook",
	8: "directive hook",
	9: "transition hook",
	10: "app errorHandler",
	11: "app warnHandler",
	12: "ref function",
	13: "async component loader",
	14: "scheduler flush",
	15: "component update",
	16: "app unmount cleanup function"
};
function un(e, t, n, r) {
	try {
		return r ? e(...r) : e();
	} catch (e) {
		fn(e, t, n);
	}
}
function dn(e, t, n, r) {
	if (w(e)) {
		let i = un(e, t, n, r);
		return i && oe(i) && i.catch((e) => {
			fn(e, t, n);
		}), i;
	}
	if (C(e)) {
		let i = [];
		for (let a = 0; a < e.length; a++) i.push(dn(e[a], t, n, r));
		return i;
	} else process.env.NODE_ENV !== "production" && M(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`);
}
function fn(e, t, n, r = !0) {
	let i = t ? t.vnode : null, { errorHandler: a, throwUnhandledErrorInProduction: o } = t && t.appContext.config || v;
	if (t) {
		let r = t.parent, i = t.proxy, o = process.env.NODE_ENV === "production" ? `https://vuejs.org/error-reference/#runtime-${n}` : ln[n];
		for (; r;) {
			let t = r.ec;
			if (t) {
				for (let n = 0; n < t.length; n++) if (t[n](e, i, o) === !1) return;
			}
			r = r.parent;
		}
		if (a) {
			Ve(), un(a, null, 10, [
				e,
				i,
				o
			]), He();
			return;
		}
	}
	pn(e, n, i, r, o);
}
function pn(e, t, n, r = !0, i = !1) {
	if (process.env.NODE_ENV !== "production") {
		let i = ln[t];
		if (n && en(n), M(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && tn(), r) throw e;
		console.error(e);
	} else if (i) throw e;
	else console.error(e);
}
var N = [], mn = -1, hn = [], gn = null, _n = 0, vn = /* @__PURE__ */ Promise.resolve(), yn = null, bn = 100;
function xn(e) {
	let t = yn || vn;
	return e ? t.then(this ? e.bind(this) : e) : t;
}
function Sn(e) {
	let t = mn + 1, n = N.length;
	for (; t < n;) {
		let r = t + n >>> 1, i = N[r], a = Dn(i);
		a < e || a === e && i.flags & 2 ? t = r + 1 : n = r;
	}
	return t;
}
function Cn(e) {
	if (!(e.flags & 1)) {
		let t = Dn(e), n = N[N.length - 1];
		!n || !(e.flags & 2) && t >= Dn(n) ? N.push(e) : N.splice(Sn(t), 0, e), e.flags |= 1, wn();
	}
}
function wn() {
	yn ||= vn.then(On);
}
function Tn(e) {
	C(e) ? hn.push(...e) : gn && e.id === -1 ? gn.splice(_n + 1, 0, e) : e.flags & 1 || (hn.push(e), e.flags |= 1), wn();
}
function En(e) {
	if (hn.length) {
		let t = [...new Set(hn)].sort((e, t) => Dn(e) - Dn(t));
		if (hn.length = 0, gn) {
			gn.push(...t);
			return;
		}
		for (gn = t, process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map()), _n = 0; _n < gn.length; _n++) {
			let t = gn[_n];
			process.env.NODE_ENV !== "production" && kn(e, t) || (t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2);
		}
		gn = null, _n = 0;
	}
}
var Dn = (e) => e.id == null ? e.flags & 2 ? -1 : Infinity : e.id;
function On(e) {
	process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map());
	let t = process.env.NODE_ENV === "production" ? y : (t) => kn(e, t);
	try {
		for (mn = 0; mn < N.length; mn++) {
			let e = N[mn];
			if (e && !(e.flags & 8)) {
				if (process.env.NODE_ENV !== "production" && t(e)) continue;
				e.flags & 4 && (e.flags &= -2), un(e, e.i, e.i ? 15 : 14), e.flags & 4 || (e.flags &= -2);
			}
		}
	} finally {
		for (; mn < N.length; mn++) {
			let e = N[mn];
			e && (e.flags &= -2);
		}
		mn = -1, N.length = 0, En(e), yn = null, (N.length || hn.length) && On(e);
	}
}
function kn(e, t) {
	let n = e.get(t) || 0;
	if (n > bn) {
		let e = t.i, n = e && Jr(e.type);
		return fn(`Maximum recursive updates exceeded${n ? ` in component <${n}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10), !0;
	}
	return e.set(t, n + 1), !1;
}
var An = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (ge().__VUE_HMR_RUNTIME__ = {
	createRecord: Ln(Mn),
	rerender: Ln(Pn),
	reload: Ln(Fn)
});
var jn = /* @__PURE__ */ new Map();
function Mn(e, t) {
	return jn.has(e) ? !1 : (jn.set(e, {
		initialDef: Nn(t),
		instances: /* @__PURE__ */ new Set()
	}), !0);
}
function Nn(e) {
	return Xr(e) ? e.__vccOpts : e;
}
function Pn(e, t) {
	let n = jn.get(e);
	n && (n.initialDef.render = t, [...n.instances].forEach((e) => {
		t && (e.render = t, Nn(e.type).render = t), e.renderCache = [], e.job.flags & 8 || e.update();
	}));
}
function Fn(e, t) {
	let n = jn.get(e);
	if (!n) return;
	t = Nn(t), In(n.initialDef, t);
	let r = [...n.instances];
	for (let e = 0; e < r.length; e++) {
		let i = r[e], a = Nn(i.type), o = An.get(a);
		o || (a !== n.initialDef && In(a, t), An.set(a, o = /* @__PURE__ */ new Set())), o.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (o.add(i), i.ceReload(t.styles), o.delete(i)) : i.parent ? Cn(() => {
			i.job.flags & 8 || (i.parent.update(), o.delete(i));
		}) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn("[HMR] Root or manually mounted instance modified. Full reload required."), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(a);
	}
	Tn(() => {
		An.clear();
	});
}
function In(e, t) {
	x(e, t);
	for (let n in e) n !== "__file" && !(n in t) && delete e[n];
}
function Ln(e) {
	return (t, n) => {
		try {
			return e(t, n);
		} catch (e) {
			console.error(e), console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
		}
	};
}
var Rn, zn = [];
function Bn(e, t) {
	Rn = e, Rn ? (Rn.enabled = !0, zn.forEach(({ event: e, args: t }) => Rn.emit(e, ...t)), zn = []) : typeof window < "u" && window.HTMLElement && !(window.navigator?.userAgent)?.includes("jsdom") ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((e) => {
		Bn(e, t);
	}), setTimeout(() => {
		Rn || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, zn = []);
	}, 3e3)) : zn = [];
}
var Vn = null, Hn = null;
function Un(e, t, n = !1) {
	let r = Br();
	if (r || mr) {
		let i = mr ? mr._context.provides : r ? r.parent == null || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
		if (i && e in i) return i[e];
		if (arguments.length > 1) return n && w(t) ? t.call(r && r.proxy) : t;
		process.env.NODE_ENV !== "production" && M(`injection "${String(e)}" not found.`);
	} else process.env.NODE_ENV !== "production" && M("inject() can only be used inside setup() or functional components.");
}
var Wn = /* @__PURE__ */ Symbol.for("v-scx"), Gn = () => {
	{
		let e = Un(Wn);
		return e || process.env.NODE_ENV !== "production" && M("Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."), e;
	}
};
function Kn(e, t, n = v) {
	let { immediate: r, deep: i, flush: a, once: o } = n;
	process.env.NODE_ENV !== "production" && !t && (r !== void 0 && M("watch() \"immediate\" option is only respected when using the watch(source, callback, options?) signature."), i !== void 0 && M("watch() \"deep\" option is only respected when using the watch(source, callback, options?) signature."), o !== void 0 && M("watch() \"once\" option is only respected when using the watch(source, callback, options?) signature."));
	let s = x({}, n);
	process.env.NODE_ENV !== "production" && (s.onWarn = M);
	let c = t && r || !t && a !== "post", l;
	if (Wr) {
		if (a === "sync") {
			let e = Gn();
			l = e.__watcherHandles ||= [];
		} else if (!c) {
			let e = () => {};
			return e.stop = y, e.resume = y, e.pause = y, e;
		}
	}
	let u = zr;
	s.call = (e, t, n) => dn(e, u, t, n);
	let d = !1;
	a === "post" ? s.scheduler = (e) => {
		_r(e, u && u.suspense);
	} : a !== "sync" && (d = !0, s.scheduler = (e, t) => {
		t ? e() : Cn(e);
	}), s.augmentJob = (e) => {
		t && (e.flags |= 4), d && (e.flags |= 2, u && (e.id = u.uid, e.i = u));
	};
	let f = Zt(e, t, s);
	return Wr && (l ? l.push(f) : c && f()), f;
}
function qn(e, t, n) {
	let r = this.proxy, i = ie(e) ? e.includes(".") ? Jn(r, e) : () => r[e] : e.bind(r, r), a;
	w(t) ? a = t : (a = t.handler, n = t);
	let o = Hr(this), s = Kn(i, a.bind(r), n);
	return o(), s;
}
function Jn(e, t) {
	let n = t.split(".");
	return () => {
		let t = e;
		for (let e = 0; e < n.length && t; e++) t = t[n[e]];
		return t;
	};
}
var Yn = (e) => e.__isTeleport;
function Xn(e, t) {
	e.shapeFlag & 6 && e.component ? (e.transition = t, Xn(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
ge().requestIdleCallback, ge().cancelIdleCallback;
var Zn = /* @__PURE__ */ Symbol.for("v-ndc"), Qn = (e) => e ? Ur(e) ? Gr(e) : Qn(e.parent) : null, $n = /* @__PURE__ */ x(/* @__PURE__ */ Object.create(null), {
	$: (e) => e,
	$el: (e) => e.vnode.el,
	$data: (e) => e.data,
	$props: (e) => process.env.NODE_ENV === "production" ? e.props : /* @__PURE__ */ It(e.props),
	$attrs: (e) => process.env.NODE_ENV === "production" ? e.attrs : /* @__PURE__ */ It(e.attrs),
	$slots: (e) => process.env.NODE_ENV === "production" ? e.slots : /* @__PURE__ */ It(e.slots),
	$refs: (e) => process.env.NODE_ENV === "production" ? e.refs : /* @__PURE__ */ It(e.refs),
	$parent: (e) => Qn(e.parent),
	$root: (e) => Qn(e.root),
	$host: (e) => e.ce,
	$emit: (e) => e.emit,
	$options: (e) => __VUE_OPTIONS_API__ ? ar(e) : e.type,
	$forceUpdate: (e) => e.f ||= () => {
		Cn(e.update);
	},
	$nextTick: (e) => e.n ||= xn.bind(e.proxy),
	$watch: (e) => __VUE_OPTIONS_API__ ? qn.bind(e) : y
}), er = (e) => e === "_" || e === "$", tr = (e, t) => e !== v && !e.__isScriptSetup && S(e, t), nr = {
	get({ _: e }, t) {
		if (t === "__v_skip") return !0;
		let { ctx: n, setupState: r, data: i, props: a, accessCache: o, type: s, appContext: c } = e;
		if (process.env.NODE_ENV !== "production" && t === "__isVue") return !0;
		if (t[0] !== "$") {
			let e = o[t];
			if (e !== void 0) switch (e) {
				case 1: return r[t];
				case 2: return i[t];
				case 4: return n[t];
				case 3: return a[t];
			}
			else if (tr(r, t)) return o[t] = 1, r[t];
			else if (__VUE_OPTIONS_API__ && i !== v && S(i, t)) return o[t] = 2, i[t];
			else if (S(a, t)) return o[t] = 3, a[t];
			else if (n !== v && S(n, t)) return o[t] = 4, n[t];
			else (!__VUE_OPTIONS_API__ || ir) && (o[t] = 0);
		}
		let l = $n[t], u, d;
		if (l) return t === "$attrs" ? (O(e.attrs, "get", ""), process.env.NODE_ENV) : process.env.NODE_ENV !== "production" && t === "$slots" && O(e, "get", t), l(e);
		if ((u = s.__cssModules) && (u = u[t])) return u;
		if (n !== v && S(n, t)) return o[t] = 4, n[t];
		if (d = c.config.globalProperties, S(d, t)) return d[t];
		process.env.NODE_ENV !== "production" && Vn && (!ie(t) || t.indexOf("__v") !== 0) && (i !== v && er(t[0]) && S(i, t) ? M(`Property ${JSON.stringify(t)} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`) : e === Vn && M(`Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`));
	},
	set({ _: e }, t, n) {
		let { data: r, setupState: i, ctx: a } = e;
		return tr(i, t) ? (i[t] = n, !0) : process.env.NODE_ENV !== "production" && i.__isScriptSetup && S(i, t) ? (M(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : __VUE_OPTIONS_API__ && r !== v && S(r, t) ? (r[t] = n, !0) : S(e.props, t) ? (process.env.NODE_ENV !== "production" && M(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && M(`Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(a, t, {
			enumerable: !0,
			configurable: !0,
			value: n
		}) : a[t] = n, !0);
	},
	has({ _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: i, props: a, type: o } }, s) {
		let c;
		return !!(n[s] || __VUE_OPTIONS_API__ && e !== v && s[0] !== "$" && S(e, s) || tr(t, s) || S(a, s) || S(r, s) || S($n, s) || S(i.config.globalProperties, s) || (c = o.__cssModules) && c[s]);
	},
	defineProperty(e, t, n) {
		return n.get == null ? S(n, "value") && this.set(e, t, n.value, null) : e._.accessCache[t] = 0, Reflect.defineProperty(e, t, n);
	}
};
process.env.NODE_ENV !== "production" && (nr.ownKeys = (e) => (M("Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."), Reflect.ownKeys(e)));
function rr(e) {
	return C(e) ? e.reduce((e, t) => (e[t] = null, e), {}) : e;
}
var ir = !0;
function ar(e) {
	let t = e.type, { mixins: n, extends: r } = t, { mixins: i, optionsCache: a, config: { optionMergeStrategies: o } } = e.appContext, s = a.get(t), c;
	return s ? c = s : !i.length && !n && !r ? c = t : (c = {}, i.length && i.forEach((e) => or(c, e, o, !0)), or(c, t, o)), T(t) && a.set(t, c), c;
}
function or(e, t, n, r = !1) {
	let { mixins: i, extends: a } = t;
	a && or(e, a, n, !0), i && i.forEach((t) => or(e, t, n, !0));
	for (let i in t) if (r && i === "expose") process.env.NODE_ENV !== "production" && M("\"expose\" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.");
	else {
		let r = sr[i] || n && n[i];
		e[i] = r ? r(e[i], t[i]) : t[i];
	}
	return e;
}
var sr = {
	data: cr,
	props: fr,
	emits: fr,
	methods: dr,
	computed: dr,
	beforeCreate: P,
	created: P,
	beforeMount: P,
	mounted: P,
	beforeUpdate: P,
	updated: P,
	beforeDestroy: P,
	beforeUnmount: P,
	destroyed: P,
	unmounted: P,
	activated: P,
	deactivated: P,
	errorCaptured: P,
	serverPrefetch: P,
	components: dr,
	directives: dr,
	watch: pr,
	provide: cr,
	inject: lr
};
function cr(e, t) {
	return t ? e ? function() {
		return x(w(e) ? e.call(this, this) : e, w(t) ? t.call(this, this) : t);
	} : t : e;
}
function lr(e, t) {
	return dr(ur(e), ur(t));
}
function ur(e) {
	if (C(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
		return t;
	}
	return e;
}
function P(e, t) {
	return e ? [...new Set([].concat(e, t))] : t;
}
function dr(e, t) {
	return e ? x(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function fr(e, t) {
	return e ? C(e) && C(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : x(/* @__PURE__ */ Object.create(null), rr(e), rr(t ?? {})) : t;
}
function pr(e, t) {
	if (!e) return t;
	if (!t) return e;
	let n = x(/* @__PURE__ */ Object.create(null), e);
	for (let r in t) n[r] = P(e[r], t[r]);
	return n;
}
var mr = null, hr = {}, gr = (e) => Object.getPrototypeOf(e) === hr, _r = yr, vr = (e) => e.__isSuspense;
function yr(e, t) {
	t && t.pendingBranch ? C(e) ? t.effects.push(...e) : t.effects.push(e) : Tn(e);
}
var br = /* @__PURE__ */ Symbol.for("v-fgt"), xr = /* @__PURE__ */ Symbol.for("v-txt"), Sr = /* @__PURE__ */ Symbol.for("v-cmt"), Cr = null, wr = 1;
function Tr(e) {
	return e ? e.__v_isVNode === !0 : !1;
}
var Er, Dr = (...e) => Mr(...Er ? Er(e, Vn) : e), Or = ({ key: e }) => e ?? null, kr = ({ ref: e, ref_key: t, ref_for: n }) => (typeof e == "number" && (e = "" + e), e == null ? null : ie(e) || /* @__PURE__ */ j(e) || w(e) ? {
	i: Vn,
	r: e,
	k: t,
	f: !!n
} : e);
function Ar(e, t = null, n = null, r = 0, i = null, a = e === br ? 0 : 1, o = !1, s = !1) {
	let c = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e,
		props: t,
		key: t && Or(t),
		ref: t && kr(t),
		scopeId: Hn,
		slotScopeIds: null,
		children: n,
		component: null,
		suspense: null,
		ssContent: null,
		ssFallback: null,
		dirs: null,
		transition: null,
		el: null,
		anchor: null,
		target: null,
		targetStart: null,
		targetAnchor: null,
		staticCount: 0,
		shapeFlag: a,
		patchFlag: r,
		dynamicProps: i,
		dynamicChildren: null,
		appContext: null,
		ctx: Vn
	};
	return s ? (Lr(c, n), a & 128 && e.normalize(c)) : n && (c.shapeFlag |= ie(n) ? 8 : 16), process.env.NODE_ENV !== "production" && c.key !== c.key && M("VNode created with invalid key (NaN). VNode type:", c.type), wr > 0 && !o && Cr && (c.patchFlag > 0 || a & 6) && c.patchFlag !== 32 && Cr.push(c), c;
}
var jr = process.env.NODE_ENV === "production" ? Mr : Dr;
function Mr(e, t = null, n = null, r = 0, i = null, a = !1) {
	if ((!e || e === Zn) && (process.env.NODE_ENV !== "production" && !e && M(`Invalid vnode type when creating vnode: ${e}.`), e = Sr), Tr(e)) {
		let r = Pr(e, t, !0);
		return n && Lr(r, n), wr > 0 && !a && Cr && (r.shapeFlag & 6 ? Cr[Cr.indexOf(e)] = r : Cr.push(r)), r.patchFlag = -2, r;
	}
	if (Xr(e) && (e = e.__vccOpts), t) {
		t = Nr(t);
		let { class: e, style: n } = t;
		e && !ie(e) && (t.class = Se(e)), T(n) && (/* @__PURE__ */ Bt(n) && !C(n) && (n = x({}, n)), t.style = _e(n));
	}
	let o = ie(e) ? 1 : vr(e) ? 128 : Yn(e) ? 64 : T(e) ? 4 : w(e) ? 2 : 0;
	return process.env.NODE_ENV !== "production" && o & 4 && /* @__PURE__ */ Bt(e) && (e = /* @__PURE__ */ A(e), M("Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.", "\nComponent that was made reactive: ", e)), Ar(e, t, n, r, i, o, a, !0);
}
function Nr(e) {
	return e ? /* @__PURE__ */ Bt(e) || gr(e) ? x({}, e) : e : null;
}
function Pr(e, t, n = !1, r = !1) {
	let { props: i, ref: a, patchFlag: o, children: s, transition: c } = e, l = t ? Rr(i || {}, t) : i, u = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e.type,
		props: l,
		key: l && Or(l),
		ref: t && t.ref ? n && a ? C(a) ? a.concat(kr(t)) : [a, kr(t)] : kr(t) : a,
		scopeId: e.scopeId,
		slotScopeIds: e.slotScopeIds,
		children: process.env.NODE_ENV !== "production" && o === -1 && C(s) ? s.map(Fr) : s,
		target: e.target,
		targetStart: e.targetStart,
		targetAnchor: e.targetAnchor,
		staticCount: e.staticCount,
		shapeFlag: e.shapeFlag,
		patchFlag: t && e.type !== br ? o === -1 ? 16 : o | 16 : o,
		dynamicProps: e.dynamicProps,
		dynamicChildren: e.dynamicChildren,
		appContext: e.appContext,
		dirs: e.dirs,
		transition: c,
		component: e.component,
		suspense: e.suspense,
		ssContent: e.ssContent && Pr(e.ssContent),
		ssFallback: e.ssFallback && Pr(e.ssFallback),
		placeholder: e.placeholder,
		el: e.el,
		anchor: e.anchor,
		ctx: e.ctx,
		ce: e.ce
	};
	return c && r && Xn(u, c.clone(u)), u;
}
function Fr(e) {
	let t = Pr(e);
	return C(e.children) && (t.children = e.children.map(Fr)), t;
}
function Ir(e = " ", t = 0) {
	return jr(xr, null, e, t);
}
function Lr(e, t) {
	let n = 0, { shapeFlag: r } = e;
	if (t == null) t = null;
	else if (C(t)) n = 16;
	else if (typeof t == "object") if (r & 65) {
		let n = t.default;
		n && (n._c && (n._d = !1), Lr(e, n()), n._c && (n._d = !0));
		return;
	} else {
		n = 32;
		let r = t._;
		!r && !gr(t) ? t._ctx = Vn : r === 3 && Vn && (Vn.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
	}
	else w(t) ? (t = {
		default: t,
		_ctx: Vn
	}, n = 32) : (t = String(t), r & 64 ? (n = 16, t = [Ir(t)]) : n = 8);
	e.children = t, e.shapeFlag |= n;
}
function Rr(...e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (let e in r) if (e === "class") t.class !== r.class && (t.class = Se([t.class, r.class]));
		else if (e === "style") t.style = _e([t.style, r.style]);
		else if (b(e)) {
			let n = t[e], i = r[e];
			i && n !== i && !(C(n) && n.includes(i)) && (t[e] = n ? [].concat(n, i) : i);
		} else e !== "" && (t[e] = r[e]);
	}
	return t;
}
var zr = null, Br = () => zr || Vn, Vr;
{
	let e = ge(), t = (t, n) => {
		let r;
		return (r = e[t]) || (r = e[t] = []), r.push(n), (e) => {
			r.length > 1 ? r.forEach((t) => t(e)) : r[0](e);
		};
	};
	Vr = t("__VUE_INSTANCE_SETTERS__", (e) => zr = e), t("__VUE_SSR_SETTERS__", (e) => Wr = e);
}
var Hr = (e) => {
	let t = zr;
	return Vr(e), e.scope.on(), () => {
		e.scope.off(), Vr(t);
	};
};
function Ur(e) {
	return e.vnode.shapeFlag & 4;
}
var Wr = !1;
process.env.NODE_ENV;
function Gr(e) {
	return e.exposed ? e.exposeProxy ||= new Proxy(Kt(Vt(e.exposed)), {
		get(t, n) {
			if (n in t) return t[n];
			if (n in $n) return $n[n](e);
		},
		has(e, t) {
			return t in e || t in $n;
		}
	}) : e.proxy;
}
var Kr = /(?:^|[-_])\w/g, qr = (e) => e.replace(Kr, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function Jr(e, t = !0) {
	return w(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Yr(e, t, n = !1) {
	let r = Jr(t);
	if (!r && t.__file) {
		let e = t.__file.match(/([^/\\]+)\.\w+$/);
		e && (r = e[1]);
	}
	if (!r && e) {
		let n = (e) => {
			for (let n in e) if (e[n] === t) return n;
		};
		r = n(e.components) || e.parent && n(e.parent.type.components) || n(e.appContext.components);
	}
	return r ? qr(r) : n ? "App" : "Anonymous";
}
function Xr(e) {
	return w(e) && "__vccOpts" in e;
}
function Zr() {
	if (process.env.NODE_ENV === "production" || typeof window > "u") return;
	let e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, r = { style: "color:#eb2f96" }, i = {
		__vue_custom_formatter: !0,
		header(t) {
			if (!T(t)) return null;
			if (t.__isVue) return [
				"div",
				e,
				"VueInstance"
			];
			if (/* @__PURE__ */ j(t)) {
				Ve();
				let n = t.value;
				return He(), [
					"div",
					{},
					[
						"span",
						e,
						u(t)
					],
					"<",
					s(n),
					">"
				];
			} else if (/* @__PURE__ */ Rt(t)) return [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ k(t) ? "ShallowReactive" : "Reactive"
				],
				"<",
				s(t),
				`>${/* @__PURE__ */ zt(t) ? " (readonly)" : ""}`
			];
			else if (/* @__PURE__ */ zt(t)) return [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ k(t) ? "ShallowReadonly" : "Readonly"
				],
				"<",
				s(t),
				">"
			];
			return null;
		},
		hasBody(e) {
			return e && e.__isVue;
		},
		body(e) {
			if (e && e.__isVue) return [
				"div",
				{},
				...a(e.$)
			];
		}
	};
	function a(e) {
		let t = [];
		e.type.props && e.props && t.push(o("props", /* @__PURE__ */ A(e.props))), e.setupState !== v && t.push(o("setup", e.setupState)), e.data !== v && t.push(o("data", /* @__PURE__ */ A(e.data)));
		let n = c(e, "computed");
		n && t.push(o("computed", n));
		let i = c(e, "inject");
		return i && t.push(o("injected", i)), t.push([
			"div",
			{},
			[
				"span",
				{ style: r.style + ";opacity:0.66" },
				"$ (internal): "
			],
			["object", { object: e }]
		]), t;
	}
	function o(e, t) {
		return t = x({}, t), Object.keys(t).length ? [
			"div",
			{ style: "line-height:1.25em;margin-bottom:0.6em" },
			[
				"div",
				{ style: "color:#476582" },
				e
			],
			[
				"div",
				{ style: "padding-left:1.25em" },
				...Object.keys(t).map((e) => [
					"div",
					{},
					[
						"span",
						r,
						e + ": "
					],
					s(t[e], !1)
				])
			]
		] : ["span", {}];
	}
	function s(e, i = !0) {
		return typeof e == "number" ? [
			"span",
			t,
			e
		] : typeof e == "string" ? [
			"span",
			n,
			JSON.stringify(e)
		] : typeof e == "boolean" ? [
			"span",
			r,
			e
		] : T(e) ? ["object", { object: i ? /* @__PURE__ */ A(e) : e }] : [
			"span",
			n,
			String(e)
		];
	}
	function c(e, t) {
		let n = e.type;
		if (w(n)) return;
		let r = {};
		for (let i in e.ctx) l(n, i, t) && (r[i] = e.ctx[i]);
		return r;
	}
	function l(e, t, n) {
		let r = e[n];
		if (C(r) && r.includes(t) || T(r) && t in r || e.extends && l(e.extends, t, n) || e.mixins && e.mixins.some((e) => l(e, t, n))) return !0;
	}
	function u(e) {
		return /* @__PURE__ */ k(e) ? "ShallowRef" : e.effect ? "ComputedRef" : "Ref";
	}
	window.devtoolsFormatters ? window.devtoolsFormatters.push(i) : window.devtoolsFormatters = [i];
}
process.env.NODE_ENV, process.env.NODE_ENV, process.env.NODE_ENV;
//#endregion
//#region ../../node_modules/.pnpm/vue@3.5.30_typescript@5.5.4/node_modules/vue/dist/vue.runtime.esm-bundler.js
function Qr() {
	Zr();
}
process.env.NODE_ENV !== "production" && Qr();
//#endregion
//#region ../../libs/utils/dist/index.js
var $r = Object.create, ei = Object.defineProperty, ti = Object.getOwnPropertyDescriptor, ni = Object.getOwnPropertyNames, ri = Object.getPrototypeOf, ii = Object.prototype.hasOwnProperty, ai = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), oi = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = ni(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !ii.call(e, s) && s !== n && ei(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = ti(t, s)) || r.enumerable
	});
	return e;
}, si = (e, t, n) => (n = e == null ? {} : $r(ri(e)), oi(t || !e || !e.__esModule ? ei(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), F = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18
}, I = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE"
};
F.Dhl, F.Instabox, F.PostNl, I.PostNl, F.Bpost, I.Bpost, F.CheapCargo, I.CheapCargo, F.Dpd, I.Dpd, F.Instabox, I.Instabox, F.Dhl, I.Dhl, F.Bol, I.Bol, F.Ups, I.Ups, F.DhlForYou, I.DhlForYou, F.DhlParcelConnect, I.DhlParcelConnect, F.DhlEuroPlus, I.DhlEuroPlus, F.UpsStandard, I.UpsStandard, F.UpsExpressSaver, I.UpsExpressSaver, F.Gls, I.Gls, F.Brt, I.Brt, F.Trunkrs, I.Trunkrs, F.InPost, I.InPost, F.PosteItaliane, I.PosteItaliane, F.PostNl, I.POSTNL, F.Bpost, I.BPOST, F.CheapCargo, I.CHEAP_CARGO, F.Dpd, I.DPD, F.Instabox, I.INSTABOX, F.Dhl, I.DHL, F.Bol, I.BOL, F.Ups, I.UPS, F.DhlForYou, I.DHL_FOR_YOU, F.DhlParcelConnect, I.DHL_PARCEL_CONNECT, F.DhlEuroPlus, I.DHL_EUROPLUS, F.UpsStandard, I.UPS_STANDARD, F.UpsExpressSaver, I.UPS_EXPRESS_SAVER, F.Gls, I.GLS, F.Brt, I.BRT, F.Trunkrs, I.TRUNKRS, F.InPost, I.INPOST, F.PosteItaliane, I.POSTE_ITALIANE, I.PostNl, F.PostNl, I.POSTNL, F.PostNl, I.Bpost, F.Bpost, I.BPOST, F.Bpost, I.CheapCargo, F.CheapCargo, I.CHEAP_CARGO, F.CheapCargo, I.Dpd, F.Dpd, I.DPD, F.Dpd, I.Instabox, F.Instabox, I.Dhl, F.Dhl, I.BolCom, F.Bol, I.Bol, F.Bol, I.BOL, F.Bol, I.Ups, F.Ups, I.DhlForYou, F.DhlForYou, I.DHL_FOR_YOU, F.DhlForYou, I.DhlParcelConnect, F.DhlParcelConnect, I.DHL_PARCEL_CONNECT, F.DhlParcelConnect, I.DhlEuroPlus, F.DhlEuroPlus, I.DHL_EUROPLUS, F.DhlEuroPlus, I.UpsStandard, F.UpsStandard, I.UPS_STANDARD, F.UpsStandard, I.UpsExpressSaver, F.UpsExpressSaver, I.UPS_EXPRESS_SAVER, F.UpsExpressSaver, I.Gls, F.Gls, I.GLS, F.Gls, I.Brt, F.Brt, I.BRT, F.Brt, I.Trunkrs, F.Trunkrs, I.TRUNKRS, F.Trunkrs, I.InPost, F.InPost, I.INPOST, F.InPost, I.PosteItaliane, F.PosteItaliane, I.POSTE_ITALIANE, F.PosteItaliane;
var L = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
L.Austria, L.Belgium, L.Bulgaria, L.Croatia, L.Cyprus, L.CzechRepublic, L.Denmark, L.Estonia, L.Finland, L.France, L.Germany, L.Greece, L.Hungary, L.Ireland, L.Italy, L.Latvia, L.Lithuania, L.Luxembourg, L.Malta, L.Netherlands, L.Poland, L.Portugal, L.Romania, L.Slovakia, L.Slovenia, L.Spain, L.Sweden, Object.values(L), L.Angola, L.AntiguaAndBarbuda, L.Aruba, L.Bahamas, L.Belize, L.Benin, L.Bermuda, L.BonaireSintEustatiusAndSaba, L.Botswana, L.BurkinaFaso, L.Burundi, L.Cameroon, L.CanaryIslands, L.CentralAfricanRepublic, L.Comoros, L.CongoBrazzaville, L.CongoKinshasa, L.CoteDIvoire, L.Curacao, L.Djibouti, L.Dominica, L.DutchAntilles, L.EquatorialGuinea, L.Eritrea, L.Fiji, L.Gabon, L.Gambia, L.Ghana, L.Grenada, L.Guyana, L.HongKong, L.Kiribati, L.KoreaPeoplesDemocraticRepublic, L.Macao, L.Malawi, L.Mali, L.Mauritania, L.Nauru, L.Qatar, L.Rwanda, L.SaintKittsAndNevis, L.SaoTomeAndPrincipe, L.Seychelles, L.SierraLeone, L.SintMaarten, L.Suriname, L.SyrianArabRepublic, L.TimorLeste, L.Togo, L.Tonga, L.Tuvalu, L.Uganda, L.UnitedArabEmirates, L.Vanuatu, L.Yemen, L.Zimbabwe, L.Austria, L.Belgium, L.Bulgaria, L.Croatia, L.CzechRepublic, L.Estonia, L.Finland, L.France, L.Germany, L.Greece, L.Hungary, L.Ireland, L.Italy, L.Latvia, L.Lithuania, L.Luxembourg, L.Malta, L.Netherlands, L.Portugal, L.Romania, L.Slovakia, L.Slovenia, L.Spain, L.UnitedKingdom, L.Denmark, L.Germany, L.Sweden;
var R = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, z = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, ci = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
R.EarlyMorning, z.EarlyMorning, R.Morning, z.Morning, R.Standard, z.Standard, R.Evening, z.Evening, R.Pickup, z.Pickup, R.PickupExpress, z.PickupExpress, R.SameDayDelivery, z.SameDayDelivery, R.Express, z.Express, z.EarlyMorning, R.EarlyMorning, z.Morning, R.Morning, z.Standard, R.Standard, z.Evening, R.Evening, z.Pickup, R.Pickup, z.PickupExpress, R.PickupExpress, z.SameDayDelivery, R.SameDayDelivery, z.Express, R.Express, R.EarlyMorning, ci.EarlyMorning, R.Morning, ci.Morning, R.Standard, ci.Standard, R.Evening, ci.Evening, R.Pickup, ci.Pickup, R.PickupExpress, ci.PickupExpress, R.SameDayDelivery, ci.SameDayDelivery, R.Express, ci.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var B = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, V = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
V.Sunday, B.Sunday, V.Monday, B.Monday, V.Tuesday, B.Tuesday, V.Wednesday, B.Wednesday, V.Thursday, B.Thursday, V.Friday, B.Friday, V.Saturday, B.Saturday, B.Sunday, V.Sunday, B.Monday, V.Monday, B.Tuesday, V.Tuesday, B.Wednesday, V.Wednesday, B.Thursday, V.Thursday, B.Friday, V.Friday, B.Saturday, V.Saturday;
var li = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
li.Bytes, li.Kilobytes, li.Megabytes, li.Gigabytes, li.Terabytes;
var H = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, U = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
H.Bol, U.Bol, H.Exact, U.Exact, H.Amazon, U.Amazon, H.Wix, U.Wix, H.ExactDe, U.ExactDe, H.Etsy, U.Etsy, U.Bol, H.Bol, U.Exact, H.Exact, U.Amazon, H.Amazon, U.Wix, H.Wix, U.ExactDe, H.ExactDe, U.Etsy, H.Etsy;
var W = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, G = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
W.Unpaid, G.Unpaid, W.Due, G.Due, W.DuePrepayment, G.DuePrepayment, W.Reminder1, G.Reminder1, W.Reminder2, G.Reminder2, W.Dun, G.Dun, W.Collection, G.Collection, W.Instalments, G.Instalments, W.PaymentArrangement, G.PaymentArrangement, W.Dispute, G.Dispute, W.LegalProcedure, G.LegalProcedure, W.Insolvency, G.Insolvency, W.WriteOff, G.WriteOff, W.Pending, G.Pending, W.Cancelled, G.Cancelled, W.Paid, G.Paid, W.PaidOnline, G.PaidOnline, W.PaidAutomatic, G.PaidAutomatic, W.PaidCredit, G.PaidCredit, W.PaidZeroItems, G.PaidZeroItems, W.InvoiceWith0InvoiceItemsPaidZeroBalance, G.PaidZeroBalance, W.Due, W.Reminder1, W.Reminder2, W.Dun, W.Collection, W.Instalments, W.PaymentArrangement, W.Dispute, W.Paid, W.PaidOnline, W.PaidAutomatic, W.PaidCredit, W.PaidZeroItems;
var ui = {
	Gram: "gram",
	Kilogram: "kilogram"
}, K = {
	Gram: "g",
	Kilogram: "kg"
}, di = {
	[K.Gram]: 1,
	[K.Kilogram]: 1e3
}, fi = {
	Millimeter: "millimeter",
	Centimeter: "centimeter",
	Meter: "meter"
}, pi = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
}, mi = {
	[pi.Millimeter]: .1,
	[pi.Centimeter]: 1,
	[pi.Meter]: 100
}, q = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, J = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, hi = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
hi.Light, J.Light, hi.Start, J.Start, hi.Plus, J.Plus, hi.Premium, J.Premium, hi.Max, J.Max, J.Light, hi.Light, J.Start, hi.Start, J.Plus, hi.Plus, J.Premium, hi.Premium, J.Max, hi.Max;
var gi = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, _i = {
	Start: J.Start,
	Plus: J.Plus,
	Premium: J.Premium,
	Max: J.Max
};
gi.Start, _i.Start, gi.Plus, _i.Plus, gi.Premium, _i.Premium, gi.Max, _i.Max, _i.Start, gi.Start, _i.Plus, gi.Plus, _i.Premium, gi.Premium, _i.Max, gi.Max;
var vi = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, yi = {
	Start: J.Start,
	Plus: J.Plus,
	Premium: J.Premium,
	Max: J.Max
};
vi.Start, yi.Start, vi.Plus, yi.Plus, vi.Premium, yi.Premium, vi.Max, yi.Max, yi.Start, vi.Start, yi.Plus, vi.Plus, yi.Premium, vi.Premium, yi.Max, vi.Max;
var bi = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, xi = {
	Light: J.Light,
	Start: J.Start,
	Plus: J.Plus,
	Premium: J.Premium,
	Max: J.Max
};
bi.Light, xi.Light, bi.Start, xi.Start, bi.Plus, xi.Plus, bi.Premium, xi.Premium, bi.Max, xi.Max, xi.Light, bi.Light, xi.Start, bi.Start, xi.Plus, bi.Plus, xi.Premium, bi.Premium, xi.Max, bi.Max;
var Si = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, Ci = {
	Start: J.Start,
	Plus: J.Plus,
	Premium: J.Premium,
	Max: J.Max
};
Si.Start, Ci.Start, Si.Plus, Ci.Plus, Si.Premium, Ci.Premium, Si.Max, Ci.Max, Ci.Start, Si.Start, Ci.Plus, Si.Plus, Ci.Premium, Si.Premium, Ci.Max, Si.Max;
var Y = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, wi = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, X = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
Y.MyParcel, wi.MyParcel, Y.Flespakket, wi.Flespakket, Y.SendMyParcel, wi.SendMyParcel, Y.MyParcelIt, wi.MyParcelIt, Y.DeliverDutch, wi.DeliverDutch, Y.PostNlPlugin, wi.PostNlPlugin, Y.MyParcel, X.MyParcelNl, Y.Flespakket, X.MyParcelNl, Y.SendMyParcel, X.MyParcelBe, Y.MyParcelIt, X.MyParcelIt, Y.DeliverDutch, X.DeliverDutch, Y.PostNlPlugin, X.PostNlPlugin, X.MyParcelNl, Y.MyParcel, X.MyParcelBe, Y.SendMyParcel, X.MyParcelIt, Y.MyParcelIt, X.MyParcelNl, q.HomeCountry, L.Netherlands, q.Eu, q.Row, L.Belgium, X.MyParcelBe, q.HomeCountry, L.Belgium, L.Netherlands, q.Eu, q.Row, X.MyParcelBe, q.HomeCountry, L.Belgium, q.Eu, q.Row, X.MyParcelNl, q.HomeCountry, L.Netherlands, q.Eu, q.Row, X.MyParcelNl, q.HomeCountry, L.Netherlands, L.Belgium, L.Luxembourg, F.Bpost, F.PostNl, F.DhlForYou, F.DhlParcelConnect, F.DhlEuroPlus, F.Ups, F.UpsStandard, F.UpsExpressSaver;
var Z = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, Q = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
Z.Package, Q.Package, Z.Mailbox, Q.Mailbox, Z.Letter, Q.Letter, Z.DigitalStamp, Q.DigitalStamp, Z.Pallet, Q.Pallet, Z.PackageSmall, Q.PackageSmall, Z.Envelope, Q.Envelope, Q.Package, Z.Package, Q.Mailbox, Z.Mailbox, Q.Letter, Z.Letter, Q.DigitalStamp, Z.DigitalStamp, Q.Pallet, Z.Pallet, Q.PackageSmall, Z.PackageSmall, Q.Envelope, Z.Envelope;
var Ti = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
Z.Package, Ti.PACKAGE, Z.Mailbox, Ti.MAILBOX, Z.Letter, Ti.UNFRANKED, Z.DigitalStamp, Ti.DIGITAL_STAMP, Z.Pallet, Ti.PALLET, Z.PackageSmall, Ti.SMALL_PACKAGE, Z.Envelope, Ti.ENVELOPE;
var $ = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
$.PendingConcept, $.PendingRegistered, $.EnrouteHandedToCarrier, $.EnrouteSorting, $.EnrouteDistribution, $.DeliveredAtCustoms, $.DeliveredAtRecipient, $.DeliveredPackagePickedUp, $.DeliveredReturnShipmentPackagePickedUp, $.DeliveredAtAgreedLocation, $.PrintedLetter, $.PrintedDigitalStamp, $.InactiveConcept, $.InactiveRegistered, $.InactiveEnrouteHandedToCarrier, $.InactiveEnrouteSorting, $.InactiveEnrouteDistribution, $.InactiveEnrouteCustoms, $.InactiveDeliveredAtRecipient, $.InactiveDeliveredReadyForPickup, $.InactiveDeliveredPackagePickedUp;
var Ei = /* @__PURE__ */ ai(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, y = "en", b = {};
		b[y] = g;
		var x = "$isDayjsObject", ee = function(e) {
			return e instanceof ne || !(!e || !e[x]);
		}, te = function e(t, n, r) {
			var i;
			if (!t) return y;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				b[a] && (i = a), n && (b[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				b[s] = t, i = s;
			}
			return !r && i && (y = i), i || !r && y;
		}, S = function(e, t) {
			if (ee(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new ne(n);
		}, C = v;
		C.l = te, C.i = ee, C.w = function(e, t) {
			return S(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var ne = function() {
			function g(e) {
				this.$L = te(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[x] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (C.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return C;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = S(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return S(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < S(e);
			}, _.$g = function(e, t, n) {
				return C.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!C.u(t) || t, u = C.p(e), p = function(e, t) {
					var i = C.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return C.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var y = this.$locale().weekStart || 0, b = (h < y ? h + 7 : h) - y;
						return p(r ? _ - b : _ + (6 - b), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = C.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[C.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = C.p(u), h = function(e) {
					var t = S(p);
					return C.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return C.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = C.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return C.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return C.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return C.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return C.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return C.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return C.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return C.s(t.$s, 2, "0");
							case "SSS": return C.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = C.p(f), _ = S(r), v = (_.utcOffset() - this.utcOffset()) * t, y = this - _, b = function() {
					return C.m(h, _);
				};
				switch (g) {
					case d:
						m = b() / 12;
						break;
					case l:
						m = b();
						break;
					case u:
						m = b() / 3;
						break;
					case c:
						m = (y - v) / 6048e5;
						break;
					case s:
						m = (y - v) / 864e5;
						break;
					case o:
						m = y / n;
						break;
					case a:
						m = y / t;
						break;
					case i:
						m = y / e;
						break;
					default: m = y;
				}
				return p ? m : C.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return b[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = te(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return C.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), re = ne.prototype;
		return S.prototype = re, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			re[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), S.extend = function(e, t) {
			return e.$i ||= (e(t, ne, S), !0), S;
		}, S.locale = te, S.isDayjs = ee, S.unix = function(e) {
			return S(1e3 * e);
		}, S.en = b[y], S.Ls = b, S.p = {}, S;
	}));
})), Di = /* @__PURE__ */ ai(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Ei()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_nl = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "nl",
			weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
			weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
			weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
			months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
			monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
			ordinal: function(e) {
				return "[" + e + (e === 1 || e === 8 || e >= 20 ? "ste" : "de") + "]";
			},
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD-MM-YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "over %s",
				past: "%s geleden",
				s: "een paar seconden",
				m: "een minuut",
				mm: "%d minuten",
				h: "een uur",
				hh: "%d uur",
				d: "een dag",
				dd: "%d dagen",
				M: "een maand",
				MM: "%d maanden",
				y: "een jaar",
				yy: "%d jaar"
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), Oi = /* @__PURE__ */ ai(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Ei()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_fr = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "fr",
			weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
			weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
			weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
			months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
			monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "dans %s",
				past: "il y a %s",
				s: "quelques secondes",
				m: "une minute",
				mm: "%d minutes",
				h: "une heure",
				hh: "%d heures",
				d: "un jour",
				dd: "%d jours",
				M: "un mois",
				MM: "%d mois",
				y: "un an",
				yy: "%d ans"
			},
			ordinal: function(e) {
				return "" + e + (e === 1 ? "er" : "");
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), ki = /* @__PURE__ */ ai(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_calendar = r();
	})(e, (function() {
		return function(e, t, n) {
			var r = "h:mm A", i = {
				lastDay: "[Yesterday at] " + r,
				sameDay: "[Today at] " + r,
				nextDay: "[Tomorrow at] " + r,
				nextWeek: "dddd [at] " + r,
				lastWeek: "[Last] dddd [at] " + r,
				sameElse: "MM/DD/YYYY"
			};
			t.prototype.calendar = function(e, t) {
				var r = t || this.$locale().calendar || i, a = n(e || void 0).startOf("d"), o = this.diff(a, "d", !0), s = "sameElse", c = o < -6 ? s : o < -1 ? "lastWeek" : o < 0 ? "lastDay" : o < 1 ? "sameDay" : o < 2 ? "nextDay" : o < 7 ? "nextWeek" : s, l = r[c] || i[c];
				return typeof l == "function" ? l.call(this, n()) : this.format(l);
			};
		};
	}));
})), Ai = /* @__PURE__ */ ai(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_customParseFormat = r();
	})(e, (function() {
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, a = {}, o = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		}, s = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, c = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone ||= {}).offset = function(e) {
				if (!e || e === "Z") return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return n === 0 ? 0 : t[0] === "+" ? -n : n;
			}(e);
		}], l = function(e) {
			var t = a[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, u = function(e, t) {
			var n, r = a.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, d = {
			A: [i, function(e) {
				this.afternoon = u(e, !1);
			}],
			a: [i, function(e) {
				this.afternoon = u(e, !0);
			}],
			S: [/\d/, function(e) {
				this.milliseconds = 100 * e;
			}],
			SS: [n, function(e) {
				this.milliseconds = 10 * e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [r, s("seconds")],
			ss: [r, s("seconds")],
			m: [r, s("minutes")],
			mm: [r, s("minutes")],
			H: [r, s("hours")],
			h: [r, s("hours")],
			HH: [r, s("hours")],
			hh: [r, s("hours")],
			D: [r, s("day")],
			DD: [n, s("day")],
			Do: [i, function(e) {
				var t = a.ordinal;
				if (this.day = e.match(/\d+/)[0], t) for (var n = 1; n <= 31; n += 1) t(n).replace(/\[|\]/g, "") === e && (this.day = n);
			}],
			M: [r, s("month")],
			MM: [n, s("month")],
			MMM: [i, function(e) {
				var t = l("months"), n = (l("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw Error();
				this.month = n % 12 || n;
			}],
			MMMM: [i, function(e) {
				var t = l("months").indexOf(e) + 1;
				if (t < 1) throw Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, s("year")],
			YY: [n, function(e) {
				this.year = o(e);
			}],
			YYYY: [/\d{4}/, s("year")],
			Z: c,
			ZZ: c
		};
		function f(n) {
			for (var r = n, i = a && a.formats, o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var a = r && r.toUpperCase();
				return n || i[r] || e[r] || i[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), s = o.length, c = 0; c < s; c += 1) {
				var l = o[c], u = d[l], f = u && u[0], p = u && u[1];
				o[c] = p ? {
					regex: f,
					parser: p
				} : l.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < s; n += 1) {
					var i = o[n];
					if (typeof i == "string") r += i.length;
					else {
						var a = i.regex, c = i.parser, l = e.slice(r), u = a.exec(l)[0];
						c.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (t !== void 0) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : n === 12 && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, o = e.args;
				this.$u = r;
				var s = o[1];
				if (typeof s == "string") {
					var c = !0 === o[2], l = !0 === o[3], u = c || l, d = o[2];
					l && (d = o[2]), a = this.$locale(), !c && d && (a = n.Ls[d]), this.$d = function(e, t, n) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date((t === "X" ? 1e3 : 1) * e);
							var r = f(t)(e), i = r.year, a = r.month, o = r.day, s = r.hours, c = r.minutes, l = r.seconds, u = r.milliseconds, d = r.zone, p = /* @__PURE__ */ new Date(), m = o || (i || a ? 1 : p.getDate()), h = i || p.getFullYear(), g = 0;
							i && !a || (g = a > 0 ? a - 1 : p.getMonth());
							var _ = s || 0, v = c || 0, y = l || 0, b = u || 0;
							return d ? new Date(Date.UTC(h, g, m, _, v, y, b + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(h, g, m, _, v, y, b)) : new Date(h, g, m, _, v, y, b);
						} catch {
							return /* @__PURE__ */ new Date("");
						}
					}(t, s, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(s) && (this.$d = /* @__PURE__ */ new Date("")), a = {};
				} else if (s instanceof Array) for (var p = s.length, m = 1; m <= p; m += 1) {
					o[1] = s[m - 1];
					var h = n.apply(this, o);
					if (h.isValid()) {
						this.$d = h.$d, this.$L = h.$L, this.init();
						break;
					}
					m === p && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
})), ji = /* @__PURE__ */ ai(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isBetween = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isBetween = function(e, t, r, i) {
				var a = n(e), o = n(t), s = (i ||= "()")[0] === "(", c = i[1] === ")";
				return (s ? this.isAfter(a, r) : !this.isBefore(a, r)) && (c ? this.isBefore(o, r) : !this.isAfter(o, r)) || (s ? this.isBefore(a, r) : !this.isAfter(a, r)) && (c ? this.isAfter(o, r) : !this.isBefore(o, r));
			};
		};
	}));
})), Mi = /* @__PURE__ */ ai(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isLeapYear = r();
	})(e, (function() {
		return function(e, t) {
			t.prototype.isLeapYear = function() {
				return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
			};
		};
	}));
})), Ni = /* @__PURE__ */ ai(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_timezone = r();
	})(e, (function() {
		var e = {
			year: 0,
			month: 1,
			day: 2,
			hour: 3,
			minute: 4,
			second: 5
		}, t = {};
		return function(n, r, i) {
			var a, o = function(e, n, r) {
				r === void 0 && (r = {});
				var i = new Date(e);
				return function(e, n) {
					n === void 0 && (n = {});
					var r = n.timeZoneName || "short", i = e + "|" + r, a = t[i];
					return a || (a = new Intl.DateTimeFormat("en-US", {
						hour12: !1,
						timeZone: e,
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
						timeZoneName: r
					}), t[i] = a), a;
				}(n, r).formatToParts(i);
			}, s = function(t, n) {
				for (var r = o(t, n), a = [], s = 0; s < r.length; s += 1) {
					var c = r[s], l = c.type, u = c.value, d = e[l];
					d >= 0 && (a[d] = parseInt(u, 10));
				}
				var f = a[3], p = f === 24 ? 0 : f, m = a[0] + "-" + a[1] + "-" + a[2] + " " + p + ":" + a[4] + ":" + a[5] + ":000", h = +t;
				return (i.utc(m).valueOf() - (h -= h % 1e3)) / 6e4;
			}, c = r.prototype;
			c.tz = function(e, t) {
				e === void 0 && (e = a);
				var n = this.utcOffset(), r = this.toDate(), o = r.toLocaleString("en-US", { timeZone: e }), s = Math.round((r - new Date(o)) / 1e3 / 60), c = i(o, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(r.getTimezoneOffset() / 15) - s, !0);
				if (t) {
					var l = c.utcOffset();
					c = c.add(n - l, "minute");
				}
				return c.$x.$timezone = e, c;
			}, c.offsetName = function(e) {
				var t = this.$x.$timezone || i.tz.guess(), n = o(this.valueOf(), t, { timeZoneName: e }).find((function(e) {
					return e.type.toLowerCase() === "timezonename";
				}));
				return n && n.value;
			};
			var l = c.startOf;
			c.startOf = function(e, t) {
				if (!this.$x || !this.$x.$timezone) return l.call(this, e, t);
				var n = i(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
				return l.call(n, e, t).tz(this.$x.$timezone, !0);
			}, i.tz = function(e, t, n) {
				var r = n && t, o = n || t || a, c = s(+i(), o);
				if (typeof e != "string") return i(e).tz(o);
				var l = function(e, t, n) {
					var r = e - 60 * t * 1e3, i = s(r, n);
					if (t === i) return [r, t];
					var a = s(r -= 60 * (i - t) * 1e3, n);
					return i === a ? [r, i] : [e - 60 * Math.min(i, a) * 1e3, Math.max(i, a)];
				}(i.utc(e, r).valueOf(), c, o), u = l[0], d = l[1], f = i(u).utcOffset(d);
				return f.$x.$timezone = o, f;
			}, i.tz.guess = function() {
				return Intl.DateTimeFormat().resolvedOptions().timeZone;
			}, i.tz.setDefault = function(e) {
				a = e;
			};
		};
	}));
})), Pi = /* @__PURE__ */ ai(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_utc = r();
	})(e, (function() {
		var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
		return function(r, i, a) {
			var o = i.prototype;
			a.utc = function(e) {
				return new i({
					date: e,
					utc: !0,
					args: arguments
				});
			}, o.utc = function(t) {
				var n = a(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return t ? n.add(this.utcOffset(), e) : n;
			}, o.local = function() {
				return a(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var s = o.parse;
			o.parse = function(e) {
				e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), s.call(this, e);
			};
			var c = o.init;
			o.init = function() {
				if (this.$u) {
					var e = this.$d;
					this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
				} else c.call(this);
			};
			var l = o.utcOffset;
			o.utcOffset = function(r, i) {
				var a = this.$utils().u;
				if (a(r)) return this.$u ? 0 : a(this.$offset) ? l.call(this) : this.$offset;
				if (typeof r == "string" && (r = function(e) {
					e === void 0 && (e = "");
					var r = e.match(t);
					if (!r) return null;
					var i = ("" + r[0]).match(n) || [
						"-",
						0,
						0
					], a = i[0], o = 60 * i[1] + +i[2];
					return o === 0 ? 0 : a === "+" ? o : -o;
				}(r), r === null)) return this;
				var o = Math.abs(r) <= 16 ? 60 * r : r, s = this;
				if (i) return s.$offset = o, s.$u = r === 0, s;
				if (r !== 0) {
					var c = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
					(s = this.local().add(o + c, e)).$offset = o, s.$x.$localOffset = c;
				} else s = this.utc();
				return s;
			};
			var u = o.format;
			o.format = function(e) {
				var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return u.call(this, t);
			}, o.valueOf = function() {
				var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * e;
			}, o.isUTC = function() {
				return !!this.$u;
			}, o.toISOString = function() {
				return this.toDate().toISOString();
			}, o.toString = function() {
				return this.toDate().toUTCString();
			};
			var d = o.toDate;
			o.toDate = function(e) {
				return e === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
			};
			var f = o.diff;
			o.diff = function(e, t, n) {
				if (e && this.$u === e.$u) return f.call(this, e, t, n);
				var r = this.local(), i = a(e).local();
				return f.call(r, i, t, n);
			};
		};
	}));
}));
Di(), Oi();
var Fi = /* @__PURE__ */ si(Ei(), 1), Ii = /* @__PURE__ */ si(ki(), 1), Li = /* @__PURE__ */ si(Ai(), 1), Ri = /* @__PURE__ */ si(ji(), 1), zi = /* @__PURE__ */ si(Mi(), 1), Bi = /* @__PURE__ */ si(Ni(), 1), Vi = /* @__PURE__ */ si(Pi(), 1);
Fi.default.extend(Li.default), Fi.default.extend(zi.default), Fi.default.extend(Ii.default), Fi.default.extend(Vi.default), Fi.default.extend(Ri.default), Fi.default.extend(Bi.default), Fi.default.locale("nl"), Fi.default.tz.setDefault("Europe/Amsterdam");
var Hi = Fi.default, Ui = (e, { locale: t = "nl-NL", currency: n = "EUR", ...r } = {}) => new Intl.NumberFormat(t, {
	style: "currency",
	currency: n,
	...r
}).format(e / 100), Wi = {
	format: Ui,
	rounded: (e) => `${Ui(e, {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	})},-`,
	toCents: (e) => Math.round(e * 100),
	toNumberFromSegments: (e) => {
		if (!e) return 0;
		let t = e?.integral ?? 0, n = e?.fractional ?? 0;
		return t * 100 + n;
	},
	toNumberFromString: (e) => {
		let t = e?.trim() ?? "", n = Math.max(t.lastIndexOf("."), t.lastIndexOf(","));
		if (n >= 0) {
			let e = t.substring(0, n), r = t.substring(n + 1);
			return e = e.replace(/[.,]/g, ""), r.length < 2 ? r = r.padEnd(2, "0") : r.length > 2 && (r = r.substring(0, 2)), parseInt(e + r, 10);
		}
		return parseInt(t.replace(/[.,]/g, ""), 10);
	},
	toSegments: (e) => ({
		integral: Math.floor(e / 100),
		fractional: e % 100
	})
}, Gi = { toCentimeters: (e, t) => {
	switch (t) {
		case pi.Millimeter:
		case fi.Millimeter: return e * mi[pi.Millimeter];
		case pi.Centimeter:
		case fi.Centimeter: return e;
		case pi.Meter:
		case fi.Meter: return e * mi[pi.Meter];
		default: throw Error(`Unknown unit ${t}`);
	}
} }, Ki = { toBytes: (e) => {
	if (!e) return "0 b";
	let t = 1024, n = [
		"b",
		"kb",
		"mb",
		"gb"
	], r = Math.floor(Math.log(e) / Math.log(t));
	return `${Math.round(e / t ** r * 100) / 100} ${n[r]}`.replace(".", ",");
} }, qi = { toCeiledDecimal: (e, t = 1) => {
	let n = 10 ** t;
	return Math.ceil(e * n) / n;
} }, Ji = { toTime: (e, t) => Hi(e, "HH:mm:ss").format(t) }, Yi = { parseUrlFromDoubleSlashes: (e) => e.replace(/([^:]\/)\/+/g, "$1") }, Xi = (e, t) => {
	switch (t) {
		case K.Gram:
		case ui.Gram: return e;
		case K.Kilogram:
		case ui.Kilogram: return e * di[K.Kilogram];
		default: throw Error(`Unknown unit ${t}`);
	}
}, Zi = (e, t) => {
	switch (t) {
		case ui.Gram:
		case K.Gram: return e / di[K.Kilogram];
		case K.Kilogram:
		case ui.Kilogram: return e;
		default: throw Error(`Unknown unit ${t}`);
	}
}, Qi = (e, t, n = { round: !0 }) => {
	if (t === ui.Gram) return `${e}g`;
	if (t === ui.Kilogram) return `${n.round ? Math.round(e) : e}kg`;
	throw Error(`Unknown unit ${t}`);
}, $i = {
	currency: Wi,
	dimensions: Gi,
	weight: {
		toGrams: Xi,
		toKilograms: Zi,
		toString: Qi,
		toMinMaxString: (e, t, n) => (n === ui.Kilogram && (e = Zi(e, ui.Gram), t = Zi(t, ui.Gram)), `${Qi(e, n)} - ${Qi(t, n)}`)
	},
	time: Ji,
	url: Yi,
	fileSize: Ki,
	number: qi
};
function ea(e, t, n) {
	let r = t.split(/[.[\]]/).filter(Boolean).reduce((e, t) => e?.[t], e);
	return r === void 0 ? n : r;
}
var ta = (e, t, n) => {
	let r = t.split("."), i = r.pop(), a = /\[(\d+)\]/, o = e;
	for (let e of r) o = o[e] ??= {};
	let s = i.match(a);
	if (s) {
		let t = Number(s[1]), r = i.replace(a, "");
		return o[r] = Array.isArray(o[r]) ? o[r] : [], o[r][t] = n, e;
	}
	return o[i] = n, e;
}, na = (e) => ({ ...e }), ra = (e, t) => Object.keys(e).reduce((n, r) => (t.includes(r) || (n[r] = e[r]), n), {}), ia = (e) => {
	function t(e, n, r, i = "") {
		let a = [i, n].filter((e) => e).join(".");
		return typeof r == "object" && !Array.isArray(r) ? Object.keys(r).reduce((e, n) => t(e, n, r[n], a), e) : Object.assign(e, { [a]: r });
	}
	return Object.keys(e).reduce((n, r) => t(n, r, e[r]), {});
}, aa = (e, t) => t.reduce((t, n) => {
	let r = ea(e, n);
	return r !== void 0 && (t[n] = r), t;
}, {}), oa = {
	clone: na,
	get: ea,
	pick: aa,
	pickRename: (e, t) => {
		let n = aa(e, Object.keys(t));
		return Object.entries(t).reduce((e, [t, r]) => {
			let i = n[t];
			return i !== void 0 && (e[r] = i), e;
		}, {});
	},
	flatten: ia,
	filterKeysFromObject: ra,
	set: ta
}, sa = (e, t) => e.localeCompare(t), ca = (e, t) => t.localeCompare(e), la = {
	ascending: sa,
	descending: ca,
	byProperty: (e, t = { order: "ASC" }) => (n, r) => {
		let i = oa.get(n, e), a = oa.get(r, e), o = t.order === "ASC" ? sa : ca;
		return i ? a ? o(i, a) : t.order === "ASC" ? -1 : 1 : t.order === "ASC" ? 1 : -1;
	}
}, ua = { sortByDate: (e, t, n = { order: "ASC" }) => e.sort((e, r) => {
	let i = Hi(oa.get(e, t)).unix(), a = Hi(oa.get(r, t)).unix();
	return n.order === "ASC" ? i - a : a - i;
}) }, da = (e, t) => e - t, fa = (e, t) => t - e, pa = {
	numeric: {
		ascending: da,
		descending: fa,
		trailingZero: (e, t) => e === 0 ? 1 : t === 0 ? -1 : e - t,
		byProperty: (e, t = { order: "ASC" }) => (n, r) => {
			let i = oa.get(n, e), a = oa.get(r, e);
			if (i === a) return 0;
			let o = t.order === "ASC" ? da : fa;
			return i == null ? t.order === "ASC" ? 1 : -1 : a == null ? t.order === "ASC" ? -1 : 1 : o(i, a);
		}
	},
	alphabetical: la,
	date: ua
}, ma = {
	getWeightFactor: (e) => {
		switch (e) {
			case "g":
			case K.Gram:
			case ui.Gram: return di[K.Gram];
			case K.Kilogram:
			case ui.Kilogram: return di[K.Kilogram];
			default: throw Error(`Unknown weight unit: ${e}`);
		}
	},
	transformMetersToKilometers: (e) => {
		let t = e / 1e3;
		return t % 1 == 0 ? t : parseFloat(t.toFixed(1));
	}
};
//#endregion
export { r as _, g as a, o as b, d as c, e as d, l as f, s as g, n as h, m as i, f as l, t as m, pa as n, h as o, c as p, ma as r, u as s, $i as t, p as u, i as v, a as y };
